
<template>
  <div style="overflow-x: hidden;">
    <div>
      <template>
        <div
          id="success"
          ref="success"
          class="top-notification notification-notice hiding cleared"
          style="padding:10px 15px 35px 15px;z-index: 4;"
        >
          <div class="notification-inner">
            <span class="notification-icon"></span>
            <span class="notification-text">{{$t('homeRequestSuccessfulMessage')}}</span>
            <a @click="hideSuccessMessage" class="notification-dismiss" data-notification-dismiss></a>
          </div>
        </div>
      </template>
    </div>

    <component name="header-component" v-bind:is="headerComponent"></component>

    <main class="main">
      <div class="row">
        <div class="medium-6 column medium-push-6">
          <h3 class="page-heading">{{$t("frequentlyAskedTitle")}}</h3>
          <p class="soft">{{$t("frequentlyAskedSubtitle")}}</p>
          <div class="questions">
            <component name="articles-component" v-bind:is="articlesComponent"></component>
          </div>
        </div>
        <div class="medium-6 column medium-pull-6">
          <h3 style="margin-bottom: 25px;" class="page-heading">{{$t("submitRequestTitle")}}</h3>
          <component v-bind:is="submitRequest"></component>
        </div>
      </div>
    </main>

    <footer class="footer">
      <div class="row">
        <p class="credit flc">© 2019 {{domain}}</p>
        <div class="linkgroop">
          <a :href="`https://www.${domain}/terms`">{{$t('terms')}}</a>
          <a :href="`https://www.${domain}/privacy`">{{$t('privacy')}}</a>
          <a :href="`https://www.${domain}/dmca`">{{$t('DMCA')}}</a>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import { getComponent, eventBus } from '@/utils/common';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'home',
  metaInfo() {
    return {
      titleTemplate: `%s | ${this.$t('headerTitle')}`
    };
  },
  data() {
    return {
      success: false
    };
  },
  created() {},
  mounted() {
    eventBus.$on('requestSuccess', data => {
      if (!this.success) {
        this.success = true;
        this.$refs.success.classList.remove('cleared', 'hiding');
        setTimeout(() => {
          this.hideSuccessMessage();
        }, 3000);
      }
    });
  },
  components: { VueRecaptcha },
  computed: {
    showSuccess() {
      return this.success;
    },
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header');
    },
    articlesComponent() {
      return getComponent(this.$store.getters.flowObject, 'articles');
    },
    phoneComponent() {
      return getComponent(this.$store.getters.flowObject, 'phoneModal');
    },
    fileUploadComponent() {
      return getComponent(this.$store.getters.flowObject, 'fileUpload');
    },
    languageDropdown() {
      return getComponent(this.$store.getters.flowObject, 'languageDropdown');
    },
    submitRequest() {
      return getComponent(this.$store.getters.flowObject, 'submitRequest');
    },
    logoUrl() {
      return this.$store.state.siteDetails.logo_url;
    },
    domain() {
      return this.$store.state.siteDetails.domain_name;
    }
  },
  methods: {
    hideSuccessMessage() {
      this.$refs.success.classList.add('hiding');
      setTimeout(() => {
        this.$refs.success.classList.add('cleared');
        this.success = false;
      }, 500);
    }
  }
};
</script>

<style scoped>
.cls-1 {
  fill: #fff;
  fill-rule: evenodd;
}
#success {
  transition: visibility 0s, opacity 0.5s linear;
  visibility: visible;
  opacity: 1;
}
#success.hiding {
  opacity: 0;
}
#success.cleared {
  visibility: hidden;
}
.notification-inner {
  position: relative;
  margin: 0 auto;
  padding: 0 20px;
  max-width: 980px;
}
.notification-notice {
  background: #dbf3ff;
}

.notification-text {
  padding-left: 15px;
  padding-right: 5px;
  width: 100%;
  display: block;
  text-align: left;
}

.notification-dismiss,
.notification-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-decoration: none;
}

.notification-dismiss {
  cursor: pointer;
  right: 0;
}

.notification-icon {
  left: 0;
}

.notification-dismiss::before {
  display: inline-block;
  line-height: 20px;
  text-align: center;
  width: 20px;
}

.notification-dismiss::before {
  color: #000;
  color: initial;
  content: '\2715';
  font-family: sans-serif;
  font-size: 16px;
  opacity: 0.6;
  transition: opacity 100ms ease;
  text-decoration: none !important;
}
.top-notification {
  position: fixed;
  border: 1px solid;
  display: table;
  font-family: sans-serif;
  font-size: 12px;
  padding: 10px 15px 15px 15px !important;
  margin: 0px 0px 160px 0px !important;
  transition: height 0.2s;
  width: 100%;
  color: #555;
  text-align: center;
}
.notification-icon::before {
  content: '\2713';
  display: inline-block;
  line-height: 20px;
  text-align: center;
  width: 20px;
  border: 1px solid #b5e0f5;
  border-radius: 50%;
  font-family: 'entypo';
}

.underline {
  color: #4f9fff;
}

.cls-1 {
  fill: #fff;
  fill-rule: evenodd;
}
@import url('https://fonts.googleapis.com/css?family=Montserrat|Open+Sans:400,600');
@media print, screen and (min-width: 40.0625em) {
  .reveal,
  .reveal.large,
  .reveal.small,
  .reveal.tiny {
    right: auto;
    left: auto;
    margin: 0 auto;
  }
} /*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */
html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
}
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
hr {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}
pre {
  font-family: monospace, monospace;
  font-size: 1em;
}
a {
  background-color: transparent;
}
abbr[title] {
  border-bottom: none;
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
}
b,
strong {
  font-weight: bolder;
}
code,
kbd,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}
small {
  font-size: 80%;
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
img {
  border-style: none;
}
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}
button,
input {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
[type='button'],
[type='reset'],
[type='submit'],
button {
  -webkit-appearance: button;
}
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner,
button::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

fieldset {
  padding: 0.35em 0.75em 0.625em;
}
legend {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal;
}
progress {
  vertical-align: baseline;
}
textarea {
  overflow: auto;
}
[type='checkbox'],
[type='radio'] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
}
[type='number']::-webkit-inner-spin-button,
[type='number']::-webkit-outer-spin-button {
  height: auto;
}
[type='search'] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
[type='search']::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}
details {
  display: block;
}
summary {
  display: list-item;
}
template {
  display: none;
}
[hidden] {
  display: none;
}
.foundation-mq {
  font-family: 'small=0em&medium=40.0625em&large=64.0625em&xlarge=75em&xxlarge=90em';
}
html {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 100%;
}
*,
::after,
::before {
  -webkit-box-sizing: inherit;
  box-sizing: inherit;
}
body {
  margin: 0;
  padding: 0;
  background: #fefefe;
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-weight: 400;
  line-height: 1.5;
  color: #0a0a0a;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
img {
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
  height: auto;
  -ms-interpolation-mode: bicubic;
}
textarea {
  height: auto;
  min-height: 50px;
  border-radius: 0;
}
select {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  border-radius: 0;
}
.map_canvas embed,
.map_canvas img,
.map_canvas object,
.mqa-display embed,
.mqa-display img,
.mqa-display object {
  max-width: none !important;
}
button {
  padding: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  border-radius: 0;
  background: 0 0;
  line-height: 1;
  cursor: auto;
}
[data-whatinput='mouse'] button {
  outline: 0;
}
pre {
  overflow: auto;
}
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
}
.is-visible {
  display: block !important;
}
.is-hidden {
  display: none !important;
}
.row {
  max-width: 88.75rem;
  margin-right: auto;
  margin-left: auto;
}
.row::after,
.row::before {
  display: table;
  content: ' ';
}
.row::after {
  clear: both;
}
.row.collapse > .column,
.row.collapse > .columns {
  padding-right: 0;
  padding-left: 0;
}
.row .row {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}
@media print, screen and (min-width: 40.0625em) {
  .row .row {
    margin-right: -0.9375rem;
    margin-left: -0.9375rem;
  }
}
@media print, screen and (min-width: 64.0625em) {
  .row .row {
    margin-right: -0.9375rem;
    margin-left: -0.9375rem;
  }
}
.row .row.collapse {
  margin-right: 0;
  margin-left: 0;
}
.row.expanded {
  max-width: none;
}
.row.expanded .row {
  margin-right: auto;
  margin-left: auto;
}
.row:not(.expanded) .row {
  max-width: none;
}
.row.gutter-small > .column,
.row.gutter-small > .columns {
  padding-right: 0.625rem;
  padding-left: 0.625rem;
}
.row.gutter-medium > .column,
.row.gutter-medium > .columns {
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}
.column,
.columns {
  width: 100%;
  float: left;
  padding-right: 0.625rem;
  padding-left: 0.625rem;
}
@media print, screen and (min-width: 40.0625em) {
  .column,
  .columns {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
}
.column,
.column:last-child:not(:first-child),
.columns,
.columns:last-child:not(:first-child) {
  float: left;
  clear: none;
}
.column:last-child:not(:first-child),
.columns:last-child:not(:first-child) {
  float: right;
}
.column.end:last-child:last-child,
.end.columns:last-child:last-child {
  float: left;
}
.column.row.row,
.row.row.columns {
  float: none;
}
.row .column.row.row,
.row .row.row.columns {
  margin-right: 0;
  margin-left: 0;
  padding-right: 0;
  padding-left: 0;
}
.small-1 {
  width: 8.33333%;
}
.small-push-1 {
  position: relative;
  left: 8.33333%;
}
.small-pull-1 {
  position: relative;
  left: -8.33333%;
}
.small-offset-0 {
  margin-left: 0;
}
.small-2 {
  width: 16.66667%;
}
.small-push-2 {
  position: relative;
  left: 16.66667%;
}
.small-pull-2 {
  position: relative;
  left: -16.66667%;
}
.small-offset-1 {
  margin-left: 8.33333%;
}
.small-3 {
  width: 25%;
}
.small-push-3 {
  position: relative;
  left: 25%;
}
.small-pull-3 {
  position: relative;
  left: -25%;
}
.small-offset-2 {
  margin-left: 16.66667%;
}
.small-4 {
  width: 33.33333%;
}
.small-push-4 {
  position: relative;
  left: 33.33333%;
}
.small-pull-4 {
  position: relative;
  left: -33.33333%;
}
.small-offset-3 {
  margin-left: 25%;
}
.small-5 {
  width: 41.66667%;
}
.small-push-5 {
  position: relative;
  left: 41.66667%;
}
.small-pull-5 {
  position: relative;
  left: -41.66667%;
}
.small-offset-4 {
  margin-left: 33.33333%;
}
.small-6 {
  width: 50%;
}
.small-push-6 {
  position: relative;
  left: 50%;
}
.small-pull-6 {
  position: relative;
  left: -50%;
}
.small-offset-5 {
  margin-left: 41.66667%;
}
.small-7 {
  width: 58.33333%;
}
.small-push-7 {
  position: relative;
  left: 58.33333%;
}
.small-pull-7 {
  position: relative;
  left: -58.33333%;
}
.small-offset-6 {
  margin-left: 50%;
}
.small-8 {
  width: 66.66667%;
}
.small-push-8 {
  position: relative;
  left: 66.66667%;
}
.small-pull-8 {
  position: relative;
  left: -66.66667%;
}
.small-offset-7 {
  margin-left: 58.33333%;
}
.small-9 {
  width: 75%;
}
.small-push-9 {
  position: relative;
  left: 75%;
}
.small-pull-9 {
  position: relative;
  left: -75%;
}
.small-offset-8 {
  margin-left: 66.66667%;
}
.small-10 {
  width: 83.33333%;
}
.small-push-10 {
  position: relative;
  left: 83.33333%;
}
.small-pull-10 {
  position: relative;
  left: -83.33333%;
}
.small-offset-9 {
  margin-left: 75%;
}
.small-11 {
  width: 91.66667%;
}
.small-push-11 {
  position: relative;
  left: 91.66667%;
}
.small-pull-11 {
  position: relative;
  left: -91.66667%;
}
.small-offset-10 {
  margin-left: 83.33333%;
}
.small-12 {
  width: 100%;
}
.small-offset-11 {
  margin-left: 91.66667%;
}
.small-up-1 > .column,
.small-up-1 > .columns {
  float: left;
  width: 100%;
}
.small-up-1 > .column:nth-of-type(1n),
.small-up-1 > .columns:nth-of-type(1n) {
  clear: none;
}
.small-up-1 > .column:nth-of-type(1n + 1),
.small-up-1 > .columns:nth-of-type(1n + 1) {
  clear: both;
}
.small-up-1 > .column:last-child,
.small-up-1 > .columns:last-child {
  float: left;
}
.small-up-2 > .column,
.small-up-2 > .columns {
  float: left;
  width: 50%;
}
.small-up-2 > .column:nth-of-type(1n),
.small-up-2 > .columns:nth-of-type(1n) {
  clear: none;
}
.small-up-2 > .column:nth-of-type(2n + 1),
.small-up-2 > .columns:nth-of-type(2n + 1) {
  clear: both;
}
.small-up-2 > .column:last-child,
.small-up-2 > .columns:last-child {
  float: left;
}
.small-up-3 > .column,
.small-up-3 > .columns {
  float: left;
  width: 33.33333%;
}
.small-up-3 > .column:nth-of-type(1n),
.small-up-3 > .columns:nth-of-type(1n) {
  clear: none;
}
.small-up-3 > .column:nth-of-type(3n + 1),
.small-up-3 > .columns:nth-of-type(3n + 1) {
  clear: both;
}
.small-up-3 > .column:last-child,
.small-up-3 > .columns:last-child {
  float: left;
}
.small-up-4 > .column,
.small-up-4 > .columns {
  float: left;
  width: 25%;
}
.small-up-4 > .column:nth-of-type(1n),
.small-up-4 > .columns:nth-of-type(1n) {
  clear: none;
}
.small-up-4 > .column:nth-of-type(4n + 1),
.small-up-4 > .columns:nth-of-type(4n + 1) {
  clear: both;
}
.small-up-4 > .column:last-child,
.small-up-4 > .columns:last-child {
  float: left;
}
.small-up-5 > .column,
.small-up-5 > .columns {
  float: left;
  width: 20%;
}
.small-up-5 > .column:nth-of-type(1n),
.small-up-5 > .columns:nth-of-type(1n) {
  clear: none;
}
.small-up-5 > .column:nth-of-type(5n + 1),
.small-up-5 > .columns:nth-of-type(5n + 1) {
  clear: both;
}
.small-up-5 > .column:last-child,
.small-up-5 > .columns:last-child {
  float: left;
}
.small-up-6 > .column,
.small-up-6 > .columns {
  float: left;
  width: 16.66667%;
}
.small-up-6 > .column:nth-of-type(1n),
.small-up-6 > .columns:nth-of-type(1n) {
  clear: none;
}
.small-up-6 > .column:nth-of-type(6n + 1),
.small-up-6 > .columns:nth-of-type(6n + 1) {
  clear: both;
}
.small-up-6 > .column:last-child,
.small-up-6 > .columns:last-child {
  float: left;
}
.small-up-7 > .column,
.small-up-7 > .columns {
  float: left;
  width: 14.28571%;
}
.small-up-7 > .column:nth-of-type(1n),
.small-up-7 > .columns:nth-of-type(1n) {
  clear: none;
}
.small-up-7 > .column:nth-of-type(7n + 1),
.small-up-7 > .columns:nth-of-type(7n + 1) {
  clear: both;
}
.small-up-7 > .column:last-child,
.small-up-7 > .columns:last-child {
  float: left;
}
.small-up-8 > .column,
.small-up-8 > .columns {
  float: left;
  width: 12.5%;
}
.small-up-8 > .column:nth-of-type(1n),
.small-up-8 > .columns:nth-of-type(1n) {
  clear: none;
}
.small-up-8 > .column:nth-of-type(8n + 1),
.small-up-8 > .columns:nth-of-type(8n + 1) {
  clear: both;
}
.small-up-8 > .column:last-child,
.small-up-8 > .columns:last-child {
  float: left;
}
.small-collapse > .column,
.small-collapse > .columns {
  padding-right: 0;
  padding-left: 0;
}
.small-collapse .row {
  margin-right: 0;
  margin-left: 0;
}
.expanded.row .small-collapse.row {
  margin-right: 0;
  margin-left: 0;
}
.small-uncollapse > .column,
.small-uncollapse > .columns {
  padding-right: 0.625rem;
  padding-left: 0.625rem;
}
.small-centered {
  margin-right: auto;
  margin-left: auto;
}
.small-centered,
.small-centered:last-child:not(:first-child) {
  float: none;
  clear: both;
}
.small-pull-0,
.small-push-0,
.small-uncentered {
  position: static;
  margin-right: 0;
  margin-left: 0;
}
.small-pull-0,
.small-pull-0:last-child:not(:first-child),
.small-push-0,
.small-push-0:last-child:not(:first-child),
.small-uncentered,
.small-uncentered:last-child:not(:first-child) {
  float: left;
  clear: none;
}
.small-pull-0:last-child:not(:first-child),
.small-push-0:last-child:not(:first-child),
.small-uncentered:last-child:not(:first-child) {
  float: right;
}
@media print, screen and (min-width: 40.0625em) {
  .medium-1 {
    width: 8.33333%;
  }
  .medium-push-1 {
    position: relative;
    left: 8.33333%;
  }
  .medium-pull-1 {
    position: relative;
    left: -8.33333%;
  }
  .medium-offset-0 {
    margin-left: 0;
  }
  .medium-2 {
    width: 16.66667%;
  }
  .medium-push-2 {
    position: relative;
    left: 16.66667%;
  }
  .medium-pull-2 {
    position: relative;
    left: -16.66667%;
  }
  .medium-offset-1 {
    margin-left: 8.33333%;
  }
  .medium-3 {
    width: 25%;
  }
  .medium-push-3 {
    position: relative;
    left: 25%;
  }
  .medium-pull-3 {
    position: relative;
    left: -25%;
  }
  .medium-offset-2 {
    margin-left: 16.66667%;
  }
  .medium-4 {
    width: 33.33333%;
  }
  .medium-push-4 {
    position: relative;
    left: 33.33333%;
  }
  .medium-pull-4 {
    position: relative;
    left: -33.33333%;
  }
  .medium-offset-3 {
    margin-left: 25%;
  }
  .medium-5 {
    width: 41.66667%;
  }
  .medium-push-5 {
    position: relative;
    left: 41.66667%;
  }
  .medium-pull-5 {
    position: relative;
    left: -41.66667%;
  }
  .medium-offset-4 {
    margin-left: 33.33333%;
  }
  .medium-6 {
    width: 50%;
  }
  .medium-push-6 {
    position: relative;
    left: 50%;
  }
  .medium-pull-6 {
    position: relative;
    left: -50%;
  }
  .medium-offset-5 {
    margin-left: 41.66667%;
  }
  .medium-7 {
    width: 58.33333%;
  }
  .medium-push-7 {
    position: relative;
    left: 58.33333%;
  }
  .medium-pull-7 {
    position: relative;
    left: -58.33333%;
  }
  .medium-offset-6 {
    margin-left: 50%;
  }
  .medium-8 {
    width: 66.66667%;
  }
  .medium-push-8 {
    position: relative;
    left: 66.66667%;
  }
  .medium-pull-8 {
    position: relative;
    left: -66.66667%;
  }
  .medium-offset-7 {
    margin-left: 58.33333%;
  }
  .medium-9 {
    width: 75%;
  }
  .medium-push-9 {
    position: relative;
    left: 75%;
  }
  .medium-pull-9 {
    position: relative;
    left: -75%;
  }
  .medium-offset-8 {
    margin-left: 66.66667%;
  }
  .medium-10 {
    width: 83.33333%;
  }
  .medium-push-10 {
    position: relative;
    left: 83.33333%;
  }
  .medium-pull-10 {
    position: relative;
    left: -83.33333%;
  }
  .medium-offset-9 {
    margin-left: 75%;
  }
  .medium-11 {
    width: 91.66667%;
  }
  .medium-push-11 {
    position: relative;
    left: 91.66667%;
  }
  .medium-pull-11 {
    position: relative;
    left: -91.66667%;
  }
  .medium-offset-10 {
    margin-left: 83.33333%;
  }
  .medium-12 {
    width: 100%;
  }
  .medium-offset-11 {
    margin-left: 91.66667%;
  }
  .medium-up-1 > .column,
  .medium-up-1 > .columns {
    float: left;
    width: 100%;
  }
  .medium-up-1 > .column:nth-of-type(1n),
  .medium-up-1 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .medium-up-1 > .column:nth-of-type(1n + 1),
  .medium-up-1 > .columns:nth-of-type(1n + 1) {
    clear: both;
  }
  .medium-up-1 > .column:last-child,
  .medium-up-1 > .columns:last-child {
    float: left;
  }
  .medium-up-2 > .column,
  .medium-up-2 > .columns {
    float: left;
    width: 50%;
  }
  .medium-up-2 > .column:nth-of-type(1n),
  .medium-up-2 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .medium-up-2 > .column:nth-of-type(2n + 1),
  .medium-up-2 > .columns:nth-of-type(2n + 1) {
    clear: both;
  }
  .medium-up-2 > .column:last-child,
  .medium-up-2 > .columns:last-child {
    float: left;
  }
  .medium-up-3 > .column,
  .medium-up-3 > .columns {
    float: left;
    width: 33.33333%;
  }
  .medium-up-3 > .column:nth-of-type(1n),
  .medium-up-3 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .medium-up-3 > .column:nth-of-type(3n + 1),
  .medium-up-3 > .columns:nth-of-type(3n + 1) {
    clear: both;
  }
  .medium-up-3 > .column:last-child,
  .medium-up-3 > .columns:last-child {
    float: left;
  }
  .medium-up-4 > .column,
  .medium-up-4 > .columns {
    float: left;
    width: 25%;
  }
  .medium-up-4 > .column:nth-of-type(1n),
  .medium-up-4 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .medium-up-4 > .column:nth-of-type(4n + 1),
  .medium-up-4 > .columns:nth-of-type(4n + 1) {
    clear: both;
  }
  .medium-up-4 > .column:last-child,
  .medium-up-4 > .columns:last-child {
    float: left;
  }
  .medium-up-5 > .column,
  .medium-up-5 > .columns {
    float: left;
    width: 20%;
  }
  .medium-up-5 > .column:nth-of-type(1n),
  .medium-up-5 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .medium-up-5 > .column:nth-of-type(5n + 1),
  .medium-up-5 > .columns:nth-of-type(5n + 1) {
    clear: both;
  }
  .medium-up-5 > .column:last-child,
  .medium-up-5 > .columns:last-child {
    float: left;
  }
  .medium-up-6 > .column,
  .medium-up-6 > .columns {
    float: left;
    width: 16.66667%;
  }
  .medium-up-6 > .column:nth-of-type(1n),
  .medium-up-6 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .medium-up-6 > .column:nth-of-type(6n + 1),
  .medium-up-6 > .columns:nth-of-type(6n + 1) {
    clear: both;
  }
  .medium-up-6 > .column:last-child,
  .medium-up-6 > .columns:last-child {
    float: left;
  }
  .medium-up-7 > .column,
  .medium-up-7 > .columns {
    float: left;
    width: 14.28571%;
  }
  .medium-up-7 > .column:nth-of-type(1n),
  .medium-up-7 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .medium-up-7 > .column:nth-of-type(7n + 1),
  .medium-up-7 > .columns:nth-of-type(7n + 1) {
    clear: both;
  }
  .medium-up-7 > .column:last-child,
  .medium-up-7 > .columns:last-child {
    float: left;
  }
  .medium-up-8 > .column,
  .medium-up-8 > .columns {
    float: left;
    width: 12.5%;
  }
  .medium-up-8 > .column:nth-of-type(1n),
  .medium-up-8 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .medium-up-8 > .column:nth-of-type(8n + 1),
  .medium-up-8 > .columns:nth-of-type(8n + 1) {
    clear: both;
  }
  .medium-up-8 > .column:last-child,
  .medium-up-8 > .columns:last-child {
    float: left;
  }
  .medium-collapse > .column,
  .medium-collapse > .columns {
    padding-right: 0;
    padding-left: 0;
  }
  .medium-collapse .row {
    margin-right: 0;
    margin-left: 0;
  }
  .expanded.row .medium-collapse.row {
    margin-right: 0;
    margin-left: 0;
  }
  .medium-uncollapse > .column,
  .medium-uncollapse > .columns {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
  .medium-centered {
    margin-right: auto;
    margin-left: auto;
  }
  .medium-centered,
  .medium-centered:last-child:not(:first-child) {
    float: none;
    clear: both;
  }
  .medium-pull-0,
  .medium-push-0,
  .medium-uncentered {
    position: static;
    margin-right: 0;
    margin-left: 0;
  }
  .medium-pull-0,
  .medium-pull-0:last-child:not(:first-child),
  .medium-push-0,
  .medium-push-0:last-child:not(:first-child),
  .medium-uncentered,
  .medium-uncentered:last-child:not(:first-child) {
    float: left;
    clear: none;
  }
  .medium-pull-0:last-child:not(:first-child),
  .medium-push-0:last-child:not(:first-child),
  .medium-uncentered:last-child:not(:first-child) {
    float: right;
  }
}
@media print, screen and (min-width: 64.0625em) {
  .large-1 {
    width: 8.33333%;
  }
  .large-push-1 {
    position: relative;
    left: 8.33333%;
  }
  .large-pull-1 {
    position: relative;
    left: -8.33333%;
  }
  .large-offset-0 {
    margin-left: 0;
  }
  .large-2 {
    width: 16.66667%;
  }
  .large-push-2 {
    position: relative;
    left: 16.66667%;
  }
  .large-pull-2 {
    position: relative;
    left: -16.66667%;
  }
  .large-offset-1 {
    margin-left: 8.33333%;
  }
  .large-3 {
    width: 25%;
  }
  .large-push-3 {
    position: relative;
    left: 25%;
  }
  .large-pull-3 {
    position: relative;
    left: -25%;
  }
  .large-offset-2 {
    margin-left: 16.66667%;
  }
  .large-4 {
    width: 33.33333%;
  }
  .large-push-4 {
    position: relative;
    left: 33.33333%;
  }
  .large-pull-4 {
    position: relative;
    left: -33.33333%;
  }
  .large-offset-3 {
    margin-left: 25%;
  }
  .large-5 {
    width: 41.66667%;
  }
  .large-push-5 {
    position: relative;
    left: 41.66667%;
  }
  .large-pull-5 {
    position: relative;
    left: -41.66667%;
  }
  .large-offset-4 {
    margin-left: 33.33333%;
  }
  .large-6 {
    width: 50%;
  }
  .large-push-6 {
    position: relative;
    left: 50%;
  }
  .large-pull-6 {
    position: relative;
    left: -50%;
  }
  .large-offset-5 {
    margin-left: 41.66667%;
  }
  .large-7 {
    width: 58.33333%;
  }
  .large-push-7 {
    position: relative;
    left: 58.33333%;
  }
  .large-pull-7 {
    position: relative;
    left: -58.33333%;
  }
  .large-offset-6 {
    margin-left: 50%;
  }
  .large-8 {
    width: 66.66667%;
  }
  .large-push-8 {
    position: relative;
    left: 66.66667%;
  }
  .large-pull-8 {
    position: relative;
    left: -66.66667%;
  }
  .large-offset-7 {
    margin-left: 58.33333%;
  }
  .large-9 {
    width: 75%;
  }
  .large-push-9 {
    position: relative;
    left: 75%;
  }
  .large-pull-9 {
    position: relative;
    left: -75%;
  }
  .large-offset-8 {
    margin-left: 66.66667%;
  }
  .large-10 {
    width: 83.33333%;
  }
  .large-push-10 {
    position: relative;
    left: 83.33333%;
  }
  .large-pull-10 {
    position: relative;
    left: -83.33333%;
  }
  .large-offset-9 {
    margin-left: 75%;
  }
  .large-11 {
    width: 91.66667%;
  }
  .large-push-11 {
    position: relative;
    left: 91.66667%;
  }
  .large-pull-11 {
    position: relative;
    left: -91.66667%;
  }
  .large-offset-10 {
    margin-left: 83.33333%;
  }
  .large-12 {
    width: 100%;
  }
  .large-offset-11 {
    margin-left: 91.66667%;
  }
  .large-up-1 > .column,
  .large-up-1 > .columns {
    float: left;
    width: 100%;
  }
  .large-up-1 > .column:nth-of-type(1n),
  .large-up-1 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .large-up-1 > .column:nth-of-type(1n + 1),
  .large-up-1 > .columns:nth-of-type(1n + 1) {
    clear: both;
  }
  .large-up-1 > .column:last-child,
  .large-up-1 > .columns:last-child {
    float: left;
  }
  .large-up-2 > .column,
  .large-up-2 > .columns {
    float: left;
    width: 50%;
  }
  .large-up-2 > .column:nth-of-type(1n),
  .large-up-2 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .large-up-2 > .column:nth-of-type(2n + 1),
  .large-up-2 > .columns:nth-of-type(2n + 1) {
    clear: both;
  }
  .large-up-2 > .column:last-child,
  .large-up-2 > .columns:last-child {
    float: left;
  }
  .large-up-3 > .column,
  .large-up-3 > .columns {
    float: left;
    width: 33.33333%;
  }
  .large-up-3 > .column:nth-of-type(1n),
  .large-up-3 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .large-up-3 > .column:nth-of-type(3n + 1),
  .large-up-3 > .columns:nth-of-type(3n + 1) {
    clear: both;
  }
  .large-up-3 > .column:last-child,
  .large-up-3 > .columns:last-child {
    float: left;
  }
  .large-up-4 > .column,
  .large-up-4 > .columns {
    float: left;
    width: 25%;
  }
  .large-up-4 > .column:nth-of-type(1n),
  .large-up-4 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .large-up-4 > .column:nth-of-type(4n + 1),
  .large-up-4 > .columns:nth-of-type(4n + 1) {
    clear: both;
  }
  .large-up-4 > .column:last-child,
  .large-up-4 > .columns:last-child {
    float: left;
  }
  .large-up-5 > .column,
  .large-up-5 > .columns {
    float: left;
    width: 20%;
  }
  .large-up-5 > .column:nth-of-type(1n),
  .large-up-5 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .large-up-5 > .column:nth-of-type(5n + 1),
  .large-up-5 > .columns:nth-of-type(5n + 1) {
    clear: both;
  }
  .large-up-5 > .column:last-child,
  .large-up-5 > .columns:last-child {
    float: left;
  }
  .large-up-6 > .column,
  .large-up-6 > .columns {
    float: left;
    width: 16.66667%;
  }
  .large-up-6 > .column:nth-of-type(1n),
  .large-up-6 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .large-up-6 > .column:nth-of-type(6n + 1),
  .large-up-6 > .columns:nth-of-type(6n + 1) {
    clear: both;
  }
  .large-up-6 > .column:last-child,
  .large-up-6 > .columns:last-child {
    float: left;
  }
  .large-up-7 > .column,
  .large-up-7 > .columns {
    float: left;
    width: 14.28571%;
  }
  .large-up-7 > .column:nth-of-type(1n),
  .large-up-7 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .large-up-7 > .column:nth-of-type(7n + 1),
  .large-up-7 > .columns:nth-of-type(7n + 1) {
    clear: both;
  }
  .large-up-7 > .column:last-child,
  .large-up-7 > .columns:last-child {
    float: left;
  }
  .large-up-8 > .column,
  .large-up-8 > .columns {
    float: left;
    width: 12.5%;
  }
  .large-up-8 > .column:nth-of-type(1n),
  .large-up-8 > .columns:nth-of-type(1n) {
    clear: none;
  }
  .large-up-8 > .column:nth-of-type(8n + 1),
  .large-up-8 > .columns:nth-of-type(8n + 1) {
    clear: both;
  }
  .large-up-8 > .column:last-child,
  .large-up-8 > .columns:last-child {
    float: left;
  }
  .large-collapse > .column,
  .large-collapse > .columns {
    padding-right: 0;
    padding-left: 0;
  }
  .large-collapse .row {
    margin-right: 0;
    margin-left: 0;
  }
  .expanded.row .large-collapse.row {
    margin-right: 0;
    margin-left: 0;
  }
  .large-uncollapse > .column,
  .large-uncollapse > .columns {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
  .large-centered {
    margin-right: auto;
    margin-left: auto;
  }
  .large-centered,
  .large-centered:last-child:not(:first-child) {
    float: none;
    clear: both;
  }
  .large-pull-0,
  .large-push-0,
  .large-uncentered {
    position: static;
    margin-right: 0;
    margin-left: 0;
  }
  .large-pull-0,
  .large-pull-0:last-child:not(:first-child),
  .large-push-0,
  .large-push-0:last-child:not(:first-child),
  .large-uncentered,
  .large-uncentered:last-child:not(:first-child) {
    float: left;
    clear: none;
  }
  .large-pull-0:last-child:not(:first-child),
  .large-push-0:last-child:not(:first-child),
  .large-uncentered:last-child:not(:first-child) {
    float: right;
  }
}
.column-block {
  margin-bottom: 1.25rem;
}
.column-block > :last-child {
  margin-bottom: 0;
}
@media print, screen and (min-width: 40.0625em) {
  .column-block {
    margin-bottom: 1.875rem;
  }
  .column-block > :last-child {
    margin-bottom: 0;
  }
}
.accordion {
  margin-left: 0;
  background: #fefefe;
  list-style-type: none;
}
.accordion[disabled] .accordion-title {
  cursor: not-allowed;
}
.accordion-item:first-child > :first-child {
  border-radius: 0;
}
.accordion-item:last-child > :last-child {
  border-radius: 0;
}
.accordion-title {
  position: relative;
  display: block;
  padding: 1.25rem 1rem;
  border: 1px solid #e6e6e6;
  border-bottom: 0;
  font-size: 0.75rem;
  line-height: 1;
  color: #1779ba;
}
:last-child:not(.is-active) > .accordion-title {
  border-bottom: 1px solid #e6e6e6;
  border-radius: 0;
}
.accordion-title:focus,
.accordion-title:hover {
  background-color: #e6e6e6;
}
.accordion-title::before {
  position: absolute;
  top: 50%;
  right: 1rem;
  margin-top: -0.5rem;
  content: '+';
}
.is-active > .accordion-title::before {
  content: '\2013';
}
.accordion-content {
  display: none;
  padding: 1rem;
  border: 1px solid #e6e6e6;
  border-bottom: 0;
  background-color: #fefefe;
  color: #0a0a0a;
}
:last-child > .accordion-content:last-child {
  border-bottom: 1px solid #e6e6e6;
}
.accordion-menu li {
  width: 100%;
}
.accordion-menu a {
  padding: 0.7rem 1rem;
}
.accordion-menu .is-accordion-submenu a {
  padding: 0.7rem 1rem;
}
.accordion-menu .nested.is-accordion-submenu {
  margin-right: 0;
  margin-left: 1rem;
}
.accordion-menu.align-right .nested.is-accordion-submenu {
  margin-right: 1rem;
  margin-left: 0;
}
.accordion-menu .is-accordion-submenu-parent:not(.has-submenu-toggle) > a {
  position: relative;
}
.accordion-menu .is-accordion-submenu-parent:not(.has-submenu-toggle) > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: '';
  border-bottom-width: 0;
  border-top-style: solid;
  border-color: #1779ba transparent transparent;
  position: absolute;
  top: 50%;
  margin-top: -3px;
  right: 1rem;
}
.accordion-menu.align-left .is-accordion-submenu-parent > a::after {
  right: 1rem;
  left: auto;
}
.accordion-menu.align-right .is-accordion-submenu-parent > a::after {
  right: auto;
  left: 1rem;
}
.accordion-menu .is-accordion-submenu-parent[aria-expanded='true'] > a::after {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
}
.is-accordion-submenu-parent {
  position: relative;
}
.has-submenu-toggle > a {
  margin-right: 40px;
}
.submenu-toggle {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.submenu-toggle::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: '';
  border-bottom-width: 0;
  border-top-style: solid;
  border-color: #1779ba transparent transparent;
  top: 0;
  bottom: 0;
  margin: auto;
}
.submenu-toggle[aria-expanded='true']::after {
  -webkit-transform: scaleY(-1);
  -ms-transform: scaleY(-1);
  transform: scaleY(-1);
  -webkit-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
}
.submenu-toggle-text {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.badge {
  display: inline-block;
  min-width: 2.1em;
  padding: 0.3em;
  border-radius: 50%;
  font-size: 0.6rem;
  text-align: center;
  background: #1779ba;
  color: #fefefe;
}
.badge.primary {
  background: #1779ba;
  color: #fefefe;
}
.badge.secondary {
  background: #767676;
  color: #fefefe;
}
.badge.success {
  background: #3adb76;
  color: #0a0a0a;
}
.badge.warning {
  background: #ffae00;
  color: #0a0a0a;
}
.badge.alert {
  background: #cc4b37;
  color: #fefefe;
}
.breadcrumbs {
  margin: 0;
  list-style: none;
}
.breadcrumbs::after,
.breadcrumbs::before {
  display: table;
  content: ' ';
}
.breadcrumbs::after {
  clear: both;
}
.breadcrumbs li {
  float: left;
  font-size: 0.6875rem;
  color: #0a0a0a;
  cursor: default;
  text-transform: uppercase;
}
.breadcrumbs li:not(:last-child)::after {
  position: relative;
  margin: 0 0.75rem;
  opacity: 1;
  content: '/';
  color: #cacaca;
}
.breadcrumbs a {
  color: #1779ba;
}
.breadcrumbs a:hover {
  text-decoration: underline;
}
.breadcrumbs .disabled {
  color: #cacaca;
  cursor: not-allowed;
}
.button-group {
  margin-bottom: 1rem;
  font-size: 0;
}
.button-group::after,
.button-group::before {
  display: table;
  content: ' ';
}
.button-group::after {
  clear: both;
}
.button-group .button {
  margin: 0;
  margin-right: 1px;
  margin-bottom: 1px;
  font-size: 0.9rem;
}
.button-group .button:last-child {
  margin-right: 0;
}
.button-group.tiny .button {
  font-size: 0.6rem;
}
.button-group.small .button {
  font-size: 0.75rem;
}
.button-group.large .button {
  font-size: 1.25rem;
}
.button-group.expanded {
  margin-right: -1px;
}
.button-group.expanded::after,
.button-group.expanded::before {
  display: none;
}
.button-group.expanded .button:first-child:last-child {
  width: calc(100% - 1px);
}
.button-group.expanded .button:first-child:nth-last-child(2),
.button-group.expanded .button:first-child:nth-last-child(2):first-child:nth-last-child(2) ~ .button {
  display: inline-block;
  width: calc(50% - 1px);
  margin-right: 1px;
}
.button-group.expanded .button:first-child:nth-last-child(2):first-child:nth-last-child(2) ~ .button:last-child,
.button-group.expanded .button:first-child:nth-last-child(2):last-child {
  margin-right: -6px;
}
.button-group.expanded .button:first-child:nth-last-child(3),
.button-group.expanded .button:first-child:nth-last-child(3):first-child:nth-last-child(3) ~ .button {
  display: inline-block;
  width: calc(33.33333% - 1px);
  margin-right: 1px;
}
.button-group.expanded .button:first-child:nth-last-child(3):first-child:nth-last-child(3) ~ .button:last-child,
.button-group.expanded .button:first-child:nth-last-child(3):last-child {
  margin-right: -6px;
}
.button-group.expanded .button:first-child:nth-last-child(4),
.button-group.expanded .button:first-child:nth-last-child(4):first-child:nth-last-child(4) ~ .button {
  display: inline-block;
  width: calc(25% - 1px);
  margin-right: 1px;
}
.button-group.expanded .button:first-child:nth-last-child(4):first-child:nth-last-child(4) ~ .button:last-child,
.button-group.expanded .button:first-child:nth-last-child(4):last-child {
  margin-right: -6px;
}
.button-group.expanded .button:first-child:nth-last-child(5),
.button-group.expanded .button:first-child:nth-last-child(5):first-child:nth-last-child(5) ~ .button {
  display: inline-block;
  width: calc(20% - 1px);
  margin-right: 1px;
}
.button-group.expanded .button:first-child:nth-last-child(5):first-child:nth-last-child(5) ~ .button:last-child,
.button-group.expanded .button:first-child:nth-last-child(5):last-child {
  margin-right: -6px;
}
.button-group.expanded .button:first-child:nth-last-child(6),
.button-group.expanded .button:first-child:nth-last-child(6):first-child:nth-last-child(6) ~ .button {
  display: inline-block;
  width: calc(16.66667% - 1px);
  margin-right: 1px;
}
.button-group.expanded .button:first-child:nth-last-child(6):first-child:nth-last-child(6) ~ .button:last-child,
.button-group.expanded .button:first-child:nth-last-child(6):last-child {
  margin-right: -6px;
}
.button-group.primary .button {
  background-color: #1779ba;
  color: #fefefe;
}
.button-group.primary .button:focus,
.button-group.primary .button:hover {
  background-color: #126195;
  color: #fefefe;
}
.button-group.secondary .button {
  background-color: #767676;
  color: #fefefe;
}
.button-group.secondary .button:focus,
.button-group.secondary .button:hover {
  background-color: #5e5e5e;
  color: #fefefe;
}
.button-group.success .button {
  background-color: #3adb76;
  color: #0a0a0a;
}
.button-group.success .button:focus,
.button-group.success .button:hover {
  background-color: #22bb5b;
  color: #0a0a0a;
}
.button-group.warning .button {
  background-color: #ffae00;
  color: #0a0a0a;
}
.button-group.warning .button:focus,
.button-group.warning .button:hover {
  background-color: #cc8b00;
  color: #0a0a0a;
}
.button-group.alert .button {
  background-color: #cc4b37;
  color: #fefefe;
}
.button-group.alert .button:focus,
.button-group.alert .button:hover {
  background-color: #a53b2a;
  color: #fefefe;
}
.button-group.stacked .button,
.button-group.stacked-for-medium .button,
.button-group.stacked-for-small .button {
  width: 100%;
}
.button-group.stacked .button:last-child,
.button-group.stacked-for-medium .button:last-child,
.button-group.stacked-for-small .button:last-child {
  margin-bottom: 0;
}
.button-group.stacked-for-medium.expanded,
.button-group.stacked-for-small.expanded,
.button-group.stacked.expanded {
  margin-right: -1px;
}
.button-group.stacked-for-medium.expanded::after,
.button-group.stacked-for-medium.expanded::before,
.button-group.stacked-for-small.expanded::after,
.button-group.stacked-for-small.expanded::before,
.button-group.stacked.expanded::after,
.button-group.stacked.expanded::before {
  display: none;
}
.button-group.stacked-for-medium.expanded .button:first-child:last-child,
.button-group.stacked-for-small.expanded .button:first-child:last-child,
.button-group.stacked.expanded .button:first-child:last-child {
  width: calc(100% - 1px);
}
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(2),
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(2):first-child:nth-last-child(2) ~ .button,
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(2),
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(2):first-child:nth-last-child(2) ~ .button,
.button-group.stacked.expanded .button:first-child:nth-last-child(2),
.button-group.stacked.expanded .button:first-child:nth-last-child(2):first-child:nth-last-child(2) ~ .button {
  display: inline-block;
  width: calc(50% - 1px);
  margin-right: 1px;
}
.button-group.stacked-for-medium.expanded
  .button:first-child:nth-last-child(2):first-child:nth-last-child(2)
  ~ .button:last-child,
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(2):last-child,
.button-group.stacked-for-small.expanded
  .button:first-child:nth-last-child(2):first-child:nth-last-child(2)
  ~ .button:last-child,
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(2):last-child,
.button-group.stacked.expanded .button:first-child:nth-last-child(2):first-child:nth-last-child(2) ~ .button:last-child,
.button-group.stacked.expanded .button:first-child:nth-last-child(2):last-child {
  margin-right: -6px;
}
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(3),
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(3):first-child:nth-last-child(3) ~ .button,
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(3),
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(3):first-child:nth-last-child(3) ~ .button,
.button-group.stacked.expanded .button:first-child:nth-last-child(3),
.button-group.stacked.expanded .button:first-child:nth-last-child(3):first-child:nth-last-child(3) ~ .button {
  display: inline-block;
  width: calc(33.33333% - 1px);
  margin-right: 1px;
}
.button-group.stacked-for-medium.expanded
  .button:first-child:nth-last-child(3):first-child:nth-last-child(3)
  ~ .button:last-child,
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(3):last-child,
.button-group.stacked-for-small.expanded
  .button:first-child:nth-last-child(3):first-child:nth-last-child(3)
  ~ .button:last-child,
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(3):last-child,
.button-group.stacked.expanded .button:first-child:nth-last-child(3):first-child:nth-last-child(3) ~ .button:last-child,
.button-group.stacked.expanded .button:first-child:nth-last-child(3):last-child {
  margin-right: -6px;
}
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(4),
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(4):first-child:nth-last-child(4) ~ .button,
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(4),
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(4):first-child:nth-last-child(4) ~ .button,
.button-group.stacked.expanded .button:first-child:nth-last-child(4),
.button-group.stacked.expanded .button:first-child:nth-last-child(4):first-child:nth-last-child(4) ~ .button {
  display: inline-block;
  width: calc(25% - 1px);
  margin-right: 1px;
}
.button-group.stacked-for-medium.expanded
  .button:first-child:nth-last-child(4):first-child:nth-last-child(4)
  ~ .button:last-child,
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(4):last-child,
.button-group.stacked-for-small.expanded
  .button:first-child:nth-last-child(4):first-child:nth-last-child(4)
  ~ .button:last-child,
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(4):last-child,
.button-group.stacked.expanded .button:first-child:nth-last-child(4):first-child:nth-last-child(4) ~ .button:last-child,
.button-group.stacked.expanded .button:first-child:nth-last-child(4):last-child {
  margin-right: -6px;
}
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(5),
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(5):first-child:nth-last-child(5) ~ .button,
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(5),
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(5):first-child:nth-last-child(5) ~ .button,
.button-group.stacked.expanded .button:first-child:nth-last-child(5),
.button-group.stacked.expanded .button:first-child:nth-last-child(5):first-child:nth-last-child(5) ~ .button {
  display: inline-block;
  width: calc(20% - 1px);
  margin-right: 1px;
}
.button-group.stacked-for-medium.expanded
  .button:first-child:nth-last-child(5):first-child:nth-last-child(5)
  ~ .button:last-child,
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(5):last-child,
.button-group.stacked-for-small.expanded
  .button:first-child:nth-last-child(5):first-child:nth-last-child(5)
  ~ .button:last-child,
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(5):last-child,
.button-group.stacked.expanded .button:first-child:nth-last-child(5):first-child:nth-last-child(5) ~ .button:last-child,
.button-group.stacked.expanded .button:first-child:nth-last-child(5):last-child {
  margin-right: -6px;
}
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(6),
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(6):first-child:nth-last-child(6) ~ .button,
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(6),
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(6):first-child:nth-last-child(6) ~ .button,
.button-group.stacked.expanded .button:first-child:nth-last-child(6),
.button-group.stacked.expanded .button:first-child:nth-last-child(6):first-child:nth-last-child(6) ~ .button {
  display: inline-block;
  width: calc(16.66667% - 1px);
  margin-right: 1px;
}
.button-group.stacked-for-medium.expanded
  .button:first-child:nth-last-child(6):first-child:nth-last-child(6)
  ~ .button:last-child,
.button-group.stacked-for-medium.expanded .button:first-child:nth-last-child(6):last-child,
.button-group.stacked-for-small.expanded
  .button:first-child:nth-last-child(6):first-child:nth-last-child(6)
  ~ .button:last-child,
.button-group.stacked-for-small.expanded .button:first-child:nth-last-child(6):last-child,
.button-group.stacked.expanded .button:first-child:nth-last-child(6):first-child:nth-last-child(6) ~ .button:last-child,
.button-group.stacked.expanded .button:first-child:nth-last-child(6):last-child {
  margin-right: -6px;
}
@media print, screen and (min-width: 40.0625em) {
  .button-group.stacked-for-small .button {
    width: auto;
    margin-bottom: 0;
  }
}
@media print, screen and (min-width: 64.0625em) {
  .button-group.stacked-for-medium .button {
    width: auto;
    margin-bottom: 0;
  }
}
@media screen and (max-width: 40.06125em) {
  .button-group.stacked-for-small.expanded {
    display: block;
  }
  .button-group.stacked-for-small.expanded .button {
    display: block;
    margin-right: 0;
  }
}
@media screen and (max-width: 64.06125em) {
  .button-group.stacked-for-medium.expanded {
    display: block;
  }
  .button-group.stacked-for-medium.expanded .button {
    display: block;
    margin-right: 0;
  }
}
.callout {
  position: relative;
  margin: 0 0 1rem 0;
  padding: 1rem;
  border: 1px solid rgba(10, 10, 10, 0.25);
  border-radius: 0;
  background-color: #fff;
  color: #0a0a0a;
}
.callout > :first-child {
  margin-top: 0;
}
.callout > :last-child {
  margin-bottom: 0;
}
.callout.primary {
  background-color: #d7ecfa;
  color: #0a0a0a;
}
.callout.secondary {
  background-color: #eaeaea;
  color: #0a0a0a;
}
.callout.success {
  background-color: #e1faea;
  color: #0a0a0a;
}
.callout.warning {
  background-color: #fff3d9;
  color: #0a0a0a;
}
.callout.alert {
  background-color: #f7e4e1;
  color: #0a0a0a;
}
.callout.small {
  padding-top: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.5rem;
}
.callout.large {
  padding-top: 3rem;
  padding-right: 3rem;
  padding-bottom: 3rem;
  padding-left: 3rem;
}
.card {
  margin-bottom: 0;
  border: 1px solid #e6e6e6;
  border-radius: 0;
  background: #fefefe;
  -webkit-box-shadow: none;
  box-shadow: none;
  overflow: hidden;
  color: #0a0a0a;
}
.card > :last-child {
  margin-bottom: 0;
}
.card-divider {
  padding: 0;
  background: #e6e6e6;
}
.card-divider > :last-child {
  margin-bottom: 0;
}
.card-section {
  padding: 0;
}
.card-section > :last-child {
  margin-bottom: 0;
}
.card-image {
  min-height: 1px;
}
.close-button {
  position: absolute;
  color: #8a8a8a;
  cursor: pointer;
}
[data-whatinput='mouse'] .close-button {
  outline: 0;
}
.close-button:focus,
.close-button:hover {
  color: #0a0a0a;
}
.close-button.small {
  right: 0.66rem;
  top: 0.33em;
  font-size: 1.5em;
  line-height: 1;
}
.close-button,
.close-button.medium {
  right: 1rem;
  top: 0.5rem;
  font-size: 2em;
  line-height: 1;
}
.menu-icon {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 16px;
  cursor: pointer;
}
.menu-icon::after {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 2px;
  background: #fefefe;
  -webkit-box-shadow: 0 7px 0 #fefefe, 0 14px 0 #fefefe;
  box-shadow: 0 7px 0 #fefefe, 0 14px 0 #fefefe;
  content: '';
}
.menu-icon:hover::after {
  background: #cacaca;
  -webkit-box-shadow: 0 7px 0 #cacaca, 0 14px 0 #cacaca;
  box-shadow: 0 7px 0 #cacaca, 0 14px 0 #cacaca;
}
.menu-icon.dark {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 16px;
  cursor: pointer;
}
.menu-icon.dark::after {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 2px;
  background: #0a0a0a;
  -webkit-box-shadow: 0 7px 0 #0a0a0a, 0 14px 0 #0a0a0a;
  box-shadow: 0 7px 0 #0a0a0a, 0 14px 0 #0a0a0a;
  content: '';
}
.menu-icon.dark:hover::after {
  background: #8a8a8a;
  -webkit-box-shadow: 0 7px 0 #8a8a8a, 0 14px 0 #8a8a8a;
  box-shadow: 0 7px 0 #8a8a8a, 0 14px 0 #8a8a8a;
}
.is-drilldown {
  position: relative;
  overflow: hidden;
}
.is-drilldown li {
  display: block;
}
.is-drilldown.animate-height {
  -webkit-transition: height 0.5s;
  transition: height 0.5s;
}
.drilldown a {
  padding: 0.7rem 1rem;
  background: #fefefe;
}
.drilldown .is-drilldown-submenu {
  position: absolute;
  top: 0;
  left: 100%;
  z-index: -1;
  width: 100%;
  background: #fefefe;
  -webkit-transition: -webkit-transform 0.15s linear;
  transition: -webkit-transform 0.15s linear;
  transition: transform 0.15s linear;
  transition: transform 0.15s linear, -webkit-transform 0.15s linear;
}
.drilldown .is-drilldown-submenu.is-active {
  z-index: 1;
  display: block;
  -webkit-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  transform: translateX(-100%);
}
.drilldown .is-drilldown-submenu.is-closing {
  -webkit-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%);
}
.drilldown .is-drilldown-submenu a {
  padding: 0.7rem 1rem;
}
.drilldown .nested.is-drilldown-submenu {
  margin-right: 0;
  margin-left: 0;
}
.drilldown .drilldown-submenu-cover-previous {
  min-height: 100%;
}
.drilldown .is-drilldown-submenu-parent > a {
  position: relative;
}
.drilldown .is-drilldown-submenu-parent > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: '';
  border-right-width: 0;
  border-left-style: solid;
  border-color: transparent transparent transparent #1779ba;
  position: absolute;
  top: 50%;
  margin-top: -6px;
  right: 1rem;
}
.drilldown.align-left .is-drilldown-submenu-parent > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: '';
  border-right-width: 0;
  border-left-style: solid;
  border-color: transparent transparent transparent #1779ba;
  right: 1rem;
  left: auto;
}
.drilldown.align-right .is-drilldown-submenu-parent > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: '';
  border-left-width: 0;
  border-right-style: solid;
  border-color: transparent #1779ba transparent transparent;
  right: auto;
  left: 1rem;
}
.drilldown .js-drilldown-back > a::before {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: '';
  border-left-width: 0;
  border-right-style: solid;
  border-color: transparent #1779ba transparent transparent;
  display: inline-block;
  vertical-align: middle;
  margin-right: 0.75rem;
}
.dropdown-pane {
  position: absolute;
  z-index: 10;
  display: none;
  width: 300px;
  padding: 1rem;
  visibility: hidden;
  border: 1px solid #cacaca;
  border-radius: 0;
  background-color: #fefefe;
  font-size: 1rem;
}
.dropdown-pane.is-opening {
  display: block;
}
.dropdown-pane.is-open {
  display: block;
  visibility: visible;
}
.dropdown-pane.tiny {
  width: 100px;
}
.dropdown-pane.small {
  width: 200px;
}
.dropdown-pane.large {
  width: 400px;
}
.dropdown.menu > li.opens-left > .is-dropdown-submenu {
  top: 100%;
  right: 0;
  left: auto;
}
.dropdown.menu > li.opens-right > .is-dropdown-submenu {
  top: 100%;
  right: auto;
  left: 0;
}
.dropdown.menu > li.is-dropdown-submenu-parent > a {
  position: relative;
  padding-right: 1.5rem;
}
.dropdown.menu > li.is-dropdown-submenu-parent > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: '';
  border-bottom-width: 0;
  border-top-style: solid;
  border-color: #1779ba transparent transparent;
  right: 5px;
  left: auto;
  margin-top: -3px;
}
[data-whatinput='mouse'] .dropdown.menu a {
  outline: 0;
}
.dropdown.menu > li > a {
  background: #fefefe;
  padding: 0.7rem 1rem;
}
.dropdown.menu > li.is-active > a {
  background: 0 0;
  color: #1779ba;
}
.no-js .dropdown.menu ul {
  display: none;
}
.dropdown.menu .nested.is-dropdown-submenu {
  margin-right: 0;
  margin-left: 0;
}
.dropdown.menu.vertical > li .is-dropdown-submenu {
  top: 0;
}
.dropdown.menu.vertical > li.opens-left > .is-dropdown-submenu {
  top: 0;
  right: 100%;
  left: auto;
}
.dropdown.menu.vertical > li.opens-right > .is-dropdown-submenu {
  right: auto;
  left: 100%;
}
.dropdown.menu.vertical > li > a::after {
  right: 14px;
}
.dropdown.menu.vertical > li.opens-left > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: '';
  border-left-width: 0;
  border-right-style: solid;
  border-color: transparent #1779ba transparent transparent;
  right: auto;
  left: 5px;
}
.dropdown.menu.vertical > li.opens-right > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: '';
  border-right-width: 0;
  border-left-style: solid;
  border-color: transparent transparent transparent #1779ba;
}
@media print, screen and (min-width: 40.0625em) {
  .dropdown.menu.medium-horizontal > li.opens-left > .is-dropdown-submenu {
    top: 100%;
    right: 0;
    left: auto;
  }
  .dropdown.menu.medium-horizontal > li.opens-right > .is-dropdown-submenu {
    top: 100%;
    right: auto;
    left: 0;
  }
  .dropdown.menu.medium-horizontal > li.is-dropdown-submenu-parent > a {
    position: relative;
    padding-right: 1.5rem;
  }
  .dropdown.menu.medium-horizontal > li.is-dropdown-submenu-parent > a::after {
    display: block;
    width: 0;
    height: 0;
    border: inset 6px;
    content: '';
    border-bottom-width: 0;
    border-top-style: solid;
    border-color: #1779ba transparent transparent;
    right: 5px;
    left: auto;
    margin-top: -3px;
  }
  .dropdown.menu.medium-vertical > li .is-dropdown-submenu {
    top: 0;
  }
  .dropdown.menu.medium-vertical > li.opens-left > .is-dropdown-submenu {
    top: 0;
    right: 100%;
    left: auto;
  }
  .dropdown.menu.medium-vertical > li.opens-right > .is-dropdown-submenu {
    right: auto;
    left: 100%;
  }
  .dropdown.menu.medium-vertical > li > a::after {
    right: 14px;
  }
  .dropdown.menu.medium-vertical > li.opens-left > a::after {
    display: block;
    width: 0;
    height: 0;
    border: inset 6px;
    content: '';
    border-left-width: 0;
    border-right-style: solid;
    border-color: transparent #1779ba transparent transparent;
    right: auto;
    left: 5px;
  }
  .dropdown.menu.medium-vertical > li.opens-right > a::after {
    display: block;
    width: 0;
    height: 0;
    border: inset 6px;
    content: '';
    border-right-width: 0;
    border-left-style: solid;
    border-color: transparent transparent transparent #1779ba;
  }
}
@media print, screen and (min-width: 64.0625em) {
  .dropdown.menu.large-horizontal > li.opens-left > .is-dropdown-submenu {
    top: 100%;
    right: 0;
    left: auto;
  }
  .dropdown.menu.large-horizontal > li.opens-right > .is-dropdown-submenu {
    top: 100%;
    right: auto;
    left: 0;
  }
  .dropdown.menu.large-horizontal > li.is-dropdown-submenu-parent > a {
    position: relative;
    padding-right: 1.5rem;
  }
  .dropdown.menu.large-horizontal > li.is-dropdown-submenu-parent > a::after {
    display: block;
    width: 0;
    height: 0;
    border: inset 6px;
    content: '';
    border-bottom-width: 0;
    border-top-style: solid;
    border-color: #1779ba transparent transparent;
    right: 5px;
    left: auto;
    margin-top: -3px;
  }
  .dropdown.menu.large-vertical > li .is-dropdown-submenu {
    top: 0;
  }
  .dropdown.menu.large-vertical > li.opens-left > .is-dropdown-submenu {
    top: 0;
    right: 100%;
    left: auto;
  }
  .dropdown.menu.large-vertical > li.opens-right > .is-dropdown-submenu {
    right: auto;
    left: 100%;
  }
  .dropdown.menu.large-vertical > li > a::after {
    right: 14px;
  }
  .dropdown.menu.large-vertical > li.opens-left > a::after {
    display: block;
    width: 0;
    height: 0;
    border: inset 6px;
    content: '';
    border-left-width: 0;
    border-right-style: solid;
    border-color: transparent #1779ba transparent transparent;
    right: auto;
    left: 5px;
  }
  .dropdown.menu.large-vertical > li.opens-right > a::after {
    display: block;
    width: 0;
    height: 0;
    border: inset 6px;
    content: '';
    border-right-width: 0;
    border-left-style: solid;
    border-color: transparent transparent transparent #1779ba;
  }
}
.dropdown.menu.align-right .is-dropdown-submenu.first-sub {
  top: 100%;
  right: 0;
  left: auto;
}
.is-dropdown-menu.vertical {
  width: 100px;
}
.is-dropdown-menu.vertical.align-right {
  float: right;
}
.is-dropdown-submenu-parent {
  position: relative;
}
.is-dropdown-submenu-parent a::after {
  position: absolute;
  top: 50%;
  right: 5px;
  left: auto;
  margin-top: -6px;
}
.is-dropdown-submenu-parent.opens-inner > .is-dropdown-submenu {
  top: 100%;
  left: auto;
}
.is-dropdown-submenu-parent.opens-left > .is-dropdown-submenu {
  right: 100%;
  left: auto;
}
.is-dropdown-submenu-parent.opens-right > .is-dropdown-submenu {
  right: auto;
  left: 100%;
}
.is-dropdown-submenu {
  position: absolute;
  top: 0;
  left: 100%;
  z-index: 1;
  display: none;
  min-width: 200px;
  border: 1px solid #cacaca;
  background: #fefefe;
}
.dropdown .is-dropdown-submenu a {
  padding: 0.7rem 1rem;
}
.is-dropdown-submenu .is-dropdown-submenu-parent > a::after {
  right: 14px;
}
.is-dropdown-submenu .is-dropdown-submenu-parent.opens-left > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: '';
  border-left-width: 0;
  border-right-style: solid;
  border-color: transparent #1779ba transparent transparent;
  right: auto;
  left: 5px;
}
.is-dropdown-submenu .is-dropdown-submenu-parent.opens-right > a::after {
  display: block;
  width: 0;
  height: 0;
  border: inset 6px;
  content: '';
  border-right-width: 0;
  border-left-style: solid;
  border-color: transparent transparent transparent #1779ba;
}
.is-dropdown-submenu .is-dropdown-submenu {
  margin-top: -1px;
}
.is-dropdown-submenu > li {
  width: 100%;
}
.is-dropdown-submenu.js-dropdown-active {
  display: block;
}
.flex-video,
.responsive-embed {
  position: relative;
  height: 0;
  margin-bottom: 1rem;
  padding-bottom: 75%;
  overflow: hidden;
}
.flex-video embed,
.flex-video iframe,
.flex-video object,
.flex-video video,
.responsive-embed embed,
.responsive-embed iframe,
.responsive-embed object,
.responsive-embed video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.flex-video.widescreen,
.responsive-embed.widescreen {
  padding-bottom: 56.25%;
}
label.label,
label,
.soft {
  font-size: 15px;
  margin-bottom: 5px;
  line-height: 1.5;
  color: #676767;
  font-family: Roboto, Helvetica, Arial, sans-serif;
}
.page-heading {
  font-size: 25px;
  margin-bottom: 5px;
  line-height: 1.5;
  color: #202020;
  font-family: Roboto, Helvetica, Arial, sans-serif;
}

.label.primary {
  background: #1779ba;
  color: #fefefe;
}
.label.secondary {
  background: #767676;
  color: #fefefe;
}
.label.success {
  background: #3adb76;
  color: #0a0a0a;
}
.label.warning {
  background: #ffae00;
  color: #0a0a0a;
}
.label.alert {
  background: #cc4b37;
  color: #fefefe;
}
.media-object {
  display: block;
  margin-bottom: 0;
}
.media-object img {
  max-width: none;
}
.media-object-section {
  display: table-cell;
  vertical-align: top;
}
.media-object-section:first-child {
  padding-right: 0;
}
.media-object-section:last-child:not(:nth-child(2)) {
  padding-left: 0;
}
.media-object-section > :last-child {
  margin-bottom: 0;
}
@media screen and (max-width: 40.06125em) {
  .stack-for-small .media-object-section {
    padding: 0;
    padding-bottom: 0;
    display: block;
  }
  .stack-for-small .media-object-section img {
    width: 100%;
  }
}
.media-object-section.middle {
  vertical-align: middle;
}
.media-object-section.bottom {
  vertical-align: bottom;
}
.orbit {
  position: relative;
}
.orbit-container {
  position: relative;
  height: 0;
  margin: 0;
  list-style: none;
  overflow: hidden;
}
.orbit-slide {
  width: 100%;
  position: absolute;
}
.orbit-slide.no-motionui.is-active {
  top: 0;
  left: 0;
}
.orbit-figure {
  margin: 0;
}
.orbit-image {
  width: 100%;
  max-width: 100%;
  margin: 0;
}
.orbit-caption {
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-bottom: 0;
  padding: 1rem;
  background-color: rgba(10, 10, 10, 0.5);
  color: #fefefe;
}
.orbit-next,
.orbit-previous {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  z-index: 10;
  padding: 1rem;
  color: #fefefe;
}
[data-whatinput='mouse'] .orbit-next,
[data-whatinput='mouse'] .orbit-previous {
  outline: 0;
}
.orbit-next:active,
.orbit-next:focus,
.orbit-next:hover,
.orbit-previous:active,
.orbit-previous:focus,
.orbit-previous:hover {
  background-color: rgba(10, 10, 10, 0.5);
}
.orbit-previous {
  left: 0;
}
.orbit-next {
  left: auto;
  right: 0;
}
.orbit-bullets {
  position: relative;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
  text-align: center;
}
[data-whatinput='mouse'] .orbit-bullets {
  outline: 0;
}
.orbit-bullets button {
  width: 1.2rem;
  height: 1.2rem;
  margin: 0.1rem;
  border-radius: 50%;
  background-color: #cacaca;
}
.orbit-bullets button:hover {
  background-color: #8a8a8a;
}
.orbit-bullets button.is-active {
  background-color: #8a8a8a;
}
.pagination {
  margin-left: 0;
  margin-bottom: 0;
}
.pagination::after,
.pagination::before {
  display: table;
  content: ' ';
}
.pagination::after {
  clear: both;
}
.pagination li {
  margin-right: 0.0625rem;
  border-radius: 0;
  font-size: 0.875rem;
  display: none;
}
.pagination li:first-child,
.pagination li:last-child {
  display: inline-block;
}
@media print, screen and (min-width: 40.0625em) {
  .pagination li {
    display: inline-block;
  }
}
.pagination a,
.pagination button {
  display: block;
  padding: 0.1875rem 0.625rem;
  border-radius: 0;
  color: #0a0a0a;
}
.pagination a:hover,
.pagination button:hover {
  background: #e6e6e6;
}
.pagination .current {
  padding: 0.1875rem 0.625rem;
  background: #1779ba;
  color: #fefefe;
  cursor: default;
}
.pagination .disabled {
  padding: 0.1875rem 0.625rem;
  color: #cacaca;
  cursor: not-allowed;
}
.pagination .disabled:hover {
  background: 0 0;
}
.pagination .ellipsis::after {
  padding: 0.1875rem 0.625rem;
  content: '\2026';
  color: #0a0a0a;
}
.pagination-previous a::before,
.pagination-previous.disabled::before {
  display: inline-block;
  margin-right: 0.5rem;
  content: '\00ab';
}
.pagination-next a::after,
.pagination-next.disabled::after {
  display: inline-block;
  margin-left: 0.5rem;
  content: '\00bb';
}
.progress {
  height: 1rem;
  margin-bottom: 0;
  border-radius: 0;
  background-color: #cacaca;
}
.progress.primary .progress-meter {
  background-color: #1779ba;
}
.progress.secondary .progress-meter {
  background-color: #767676;
}
.progress.success .progress-meter {
  background-color: #3adb76;
}
.progress.warning .progress-meter {
  background-color: #ffae00;
}
.progress.alert .progress-meter {
  background-color: #cc4b37;
}
.progress-meter {
  position: relative;
  display: block;
  width: 0%;
  height: 100%;
  background-color: #1779ba;
}
.progress-meter-text {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  margin: 0;
  font-size: 0.75rem;
  font-weight: 700;
  color: #fefefe;
  white-space: nowrap;
}
.slider {
  position: relative;
  height: 0.5rem;
  margin-top: 1.25rem;
  margin-bottom: 2.25rem;
  background-color: #e6e6e6;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -ms-touch-action: none;
  touch-action: none;
}
.slider-fill {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  max-width: 100%;
  height: 0.5rem;
  background-color: #cacaca;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}
.slider-fill.is-dragging {
  -webkit-transition: all 0s linear;
  transition: all 0s linear;
}
.slider-handle {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  z-index: 1;
  display: inline-block;
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 0;
  background-color: #1779ba;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
}
[data-whatinput='mouse'] .slider-handle {
  outline: 0;
}
.slider-handle:hover {
  background-color: #14679e;
}
.slider-handle.is-dragging {
  -webkit-transition: all 0s linear;
  transition: all 0s linear;
}
.slider.disabled,
.slider[disabled] {
  opacity: 0.25;
  cursor: not-allowed;
}
.slider.vertical {
  display: inline-block;
  width: 0.5rem;
  height: 12.5rem;
  margin: 0 1.25rem;
  -webkit-transform: scale(1, -1);
  -ms-transform: scale(1, -1);
  transform: scale(1, -1);
}
.slider.vertical .slider-fill {
  top: 0;
  width: 0.5rem;
  max-height: 100%;
}
.slider.vertical .slider-handle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 1.4rem;
  height: 1.4rem;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}
.sticky-container {
  position: relative;
}
.sticky {
  position: relative;
  z-index: 0;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.sticky.is-stuck {
  position: fixed;
  z-index: 5;
  width: 100%;
}
.sticky.is-stuck.is-at-top {
  top: 0;
}
.sticky.is-stuck.is-at-bottom {
  bottom: 0;
}
.sticky.is-anchored {
  position: relative;
  right: auto;
  left: auto;
}
.sticky.is-anchored.is-at-bottom {
  bottom: 0;
}
html.is-reveal-open {
  position: fixed;
  width: 100%;
  overflow-y: hidden;
}
html.is-reveal-open.zf-has-scroll {
  overflow-y: scroll;
}
html.is-reveal-open body {
  overflow-y: hidden;
}
.reveal-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1005;
  display: none;
  background-color: rgba(10, 10, 10, 0.45);
  overflow-y: auto;
}
.reveal {
  z-index: 1006;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  display: none;
  padding: 0;
  border: 1px solid #cacaca;
  border-radius: 0;
  background-color: #fefefe;
  position: relative;
  top: 100px;
  margin-right: auto;
  margin-left: auto;
  overflow-y: auto;
}
[data-whatinput='mouse'] .reveal {
  outline: 0;
}
@media print, screen and (min-width: 40.0625em) {
  .reveal {
    min-height: 0;
  }
}
.reveal .column,
.reveal .columns {
  min-width: 0;
}
.reveal > :last-child {
  margin-bottom: 0;
}
@media print, screen and (min-width: 40.0625em) {
  .reveal {
    width: 600px;
    max-width: 88.75rem;
  }
}
.reveal.collapse {
  padding: 0;
}
@media print, screen and (min-width: 40.0625em) {
  .reveal.tiny {
    width: 30%;
    max-width: 88.75rem;
  }
}
@media print, screen and (min-width: 40.0625em) {
  .reveal.small {
    width: 50%;
    max-width: 88.75rem;
  }
}
@media print, screen and (min-width: 40.0625em) {
  .reveal.large {
    width: 90%;
    max-width: 88.75rem;
  }
}
.reveal.full {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  max-width: none;
  height: 100%;
  min-height: 100%;
  margin-left: 0;
  border: 0;
  border-radius: 0;
}
@media screen and (max-width: 40.06125em) {
  .reveal {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: none;
    height: 100%;
    min-height: 100%;
    margin-left: 0;
    border: 0;
    border-radius: 0;
  }
}
.reveal.without-overlay {
  position: fixed;
}
.switch {
  height: 2rem;
  position: relative;
  margin-bottom: 0;
  outline: 0;
  font-size: 0.875rem;
  font-weight: 700;
  color: #fefefe;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.switch-input {
  position: absolute;
  margin-bottom: 0;
  opacity: 0;
}
.switch-paddle {
  position: relative;
  display: block;
  width: 4rem;
  height: 2rem;
  border-radius: 0;
  background: #cacaca;
  -webkit-transition: all 0.25s ease-out;
  transition: all 0.25s ease-out;
  font-weight: inherit;
  color: inherit;
  cursor: pointer;
}
input + .switch-paddle {
  margin: 0;
}
.switch-paddle::after {
  position: absolute;
  top: 0.25rem;
  left: 0.25rem;
  display: block;
  width: 1.5rem;
  height: 1.5rem;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  border-radius: 0;
  background: #fefefe;
  -webkit-transition: all 0.25s ease-out;
  transition: all 0.25s ease-out;
  content: '';
}
input:checked ~ .switch-paddle {
  background: #1779ba;
}
input:checked ~ .switch-paddle::after {
  left: 2.25rem;
}
[data-whatinput='mouse'] input:focus ~ .switch-paddle {
  outline: 0;
}
.switch-active,
.switch-inactive {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.switch-active {
  left: 8%;
  display: none;
}
input:checked + label > .switch-active {
  display: block;
}
.switch-inactive {
  right: 15%;
}
input:checked + label > .switch-inactive {
  display: none;
}
.switch.tiny {
  height: 1.5rem;
}
.switch.tiny .switch-paddle {
  width: 3rem;
  height: 1.5rem;
  font-size: 0.625rem;
}
.switch.tiny .switch-paddle::after {
  top: 0.25rem;
  left: 0.25rem;
  width: 1rem;
  height: 1rem;
}
.switch.tiny input:checked ~ .switch-paddle::after {
  left: 1.75rem;
}
.switch.small {
  height: 1.75rem;
}
.switch.small .switch-paddle {
  width: 3.5rem;
  height: 1.75rem;
  font-size: 0.75rem;
}
.switch.small .switch-paddle::after {
  top: 0.25rem;
  left: 0.25rem;
  width: 1.25rem;
  height: 1.25rem;
}
.switch.small input:checked ~ .switch-paddle::after {
  left: 2rem;
}
.switch.large {
  height: 2.5rem;
}
.switch.large .switch-paddle {
  width: 5rem;
  height: 2.5rem;
  font-size: 1rem;
}
.switch.large .switch-paddle::after {
  top: 0.25rem;
  left: 0.25rem;
  width: 2rem;
  height: 2rem;
}
.switch.large input:checked ~ .switch-paddle::after {
  left: 2.75rem;
}
table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 0;
  border-radius: 0;
}
tbody,
tfoot,
thead {
  border: 1px solid #f1f1f1;
  background-color: #fefefe;
}
caption {
  padding: 0.5rem 0.625rem 0.625rem;
  font-weight: 700;
}
thead {
  background: #f8f8f8;
  color: #0a0a0a;
}
tfoot {
  background: #f1f1f1;
  color: #0a0a0a;
}
tfoot tr,
thead tr {
  background: 0 0;
}
tfoot td,
tfoot th,
thead td,
thead th {
  padding: 0.5rem 0.625rem 0.625rem;
  font-weight: 700;
  text-align: left;
}
tbody td,
tbody th {
  padding: 0.5rem 0.625rem 0.625rem;
}
tbody tr:nth-child(even) {
  border-bottom: 0;
  background-color: #f1f1f1;
}
table.unstriped tbody {
  background-color: #fefefe;
}
table.unstriped tbody tr {
  border-bottom: 0;
  border-bottom: 1px solid #f1f1f1;
  background-color: #fefefe;
}
@media screen and (max-width: 64.06125em) {
  table.stack thead {
    display: none;
  }
  table.stack tfoot {
    display: none;
  }
  table.stack td,
  table.stack th,
  table.stack tr {
    display: block;
  }
  table.stack td {
    border-top: 0;
  }
}
table.scroll {
  display: block;
  width: 100%;
  overflow-x: auto;
}
table.hover thead tr:hover {
  background-color: #f3f3f3;
}
table.hover tfoot tr:hover {
  background-color: #ececec;
}
table.hover tbody tr:hover {
  background-color: #f9f9f9;
}
table.hover:not(.unstriped) tr:nth-of-type(even):hover {
  background-color: #ececec;
}
.table-scroll {
  overflow-x: auto;
}
.tabs {
  margin: 0;
  border: 1px solid #e6e6e6;
  background: #fefefe;
  list-style-type: none;
}
.tabs::after,
.tabs::before {
  display: table;
  content: ' ';
}
.tabs::after {
  clear: both;
}
.tabs.vertical > li {
  display: block;
  float: none;
  width: auto;
}
.tabs.simple > li > a {
  padding: 0;
}
.tabs.simple > li > a:hover {
  background: 0 0;
}
.tabs.primary {
  background: #1779ba;
}
.tabs.primary > li > a {
  color: #fefefe;
}
.tabs.primary > li > a:focus,
.tabs.primary > li > a:hover {
  background: #1673b1;
}
.tabs-title {
  float: left;
}
.tabs-title > a {
  display: block;
  padding: 1.25rem 1.5rem;
  font-size: 0.75rem;
  line-height: 1;
  color: #1779ba;
}
[data-whatinput='mouse'] .tabs-title > a {
  outline: 0;
}
.tabs-title > a:hover {
  background: #fefefe;
  color: #1468a0;
}
.tabs-title > a:focus,
.tabs-title > a[aria-selected='true'] {
  background: #e6e6e6;
  color: #1779ba;
}
.tabs-content {
  border: 1px solid #e6e6e6;
  border-top: 0;
  background: #fefefe;
  color: #0a0a0a;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.tabs-content.vertical {
  border: 1px solid #e6e6e6;
  border-left: 0;
}
.tabs-panel {
  display: none;
  padding: 1rem;
}
.tabs-panel.is-active {
  display: block;
}
.thumbnail {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 0;
  border: solid 4px #fefefe;
  border-radius: 0;
  -webkit-box-shadow: 0 0 0 1px rgba(10, 10, 10, 0.2);
  box-shadow: 0 0 0 1px rgba(10, 10, 10, 0.2);
  line-height: 0;
}
a.thumbnail {
  -webkit-transition: -webkit-box-shadow 0.2s ease-out;
  transition: -webkit-box-shadow 0.2s ease-out;
  transition: box-shadow 0.2s ease-out;
  transition: box-shadow 0.2s ease-out, -webkit-box-shadow 0.2s ease-out;
}
a.thumbnail:focus,
a.thumbnail:hover {
  -webkit-box-shadow: 0 0 6px 1px rgba(23, 121, 186, 0.5);
  box-shadow: 0 0 6px 1px rgba(23, 121, 186, 0.5);
}
a.thumbnail image {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.title-bar {
  padding: 0.5rem;
  background: #0a0a0a;
  color: #fefefe;
}
.title-bar::after,
.title-bar::before {
  display: table;
  content: ' ';
}
.title-bar::after {
  clear: both;
}
.title-bar .menu-icon {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.title-bar-left {
  float: left;
}
.title-bar-right {
  float: right;
  text-align: right;
}
.title-bar-title {
  display: inline-block;
  vertical-align: middle;
  font-weight: 700;
}
.has-tip {
  position: relative;
  display: inline-block;
  border-bottom: dotted 1px #8a8a8a;
  font-weight: 700;
  cursor: help;
}
.tooltip {
  position: absolute;
  top: calc(100% + 0.6495rem);
  z-index: 1200;
  max-width: 10rem;
  padding: 0.75rem;
  border-radius: 0;
  background-color: #0a0a0a;
  font-size: 80%;
  color: #fefefe;
}
.tooltip::before {
  position: absolute;
}
.tooltip.bottom::before {
  display: block;
  width: 0;
  height: 0;
  border: inset 0.75rem;
  content: '';
  border-top-width: 0;
  border-bottom-style: solid;
  border-color: transparent transparent #0a0a0a;
  bottom: 100%;
}
.tooltip.bottom.align-center::before {
  left: 50%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}
.tooltip.top::before {
  display: block;
  width: 0;
  height: 0;
  border: inset 0.75rem;
  content: '';
  border-bottom-width: 0;
  border-top-style: solid;
  border-color: #0a0a0a transparent transparent;
  top: 100%;
  bottom: auto;
}
.tooltip.top.align-center::before {
  left: 50%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}
.tooltip.left::before {
  display: block;
  width: 0;
  height: 0;
  border: inset 0.75rem;
  content: '';
  border-right-width: 0;
  border-left-style: solid;
  border-color: transparent transparent transparent #0a0a0a;
  left: 100%;
}
.tooltip.left.align-center::before {
  bottom: auto;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.tooltip.right::before {
  display: block;
  width: 0;
  height: 0;
  border: inset 0.75rem;
  content: '';
  border-left-width: 0;
  border-right-style: solid;
  border-color: transparent #0a0a0a transparent transparent;
  right: 100%;
  left: auto;
}
.tooltip.right.align-center::before {
  bottom: auto;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.tooltip.align-top::before {
  bottom: auto;
  top: 10%;
}
.tooltip.align-bottom::before {
  bottom: 10%;
  top: auto;
}
.tooltip.align-left::before {
  left: 10%;
  right: auto;
}
.tooltip.align-right::before {
  left: auto;
  right: 10%;
}
.top-bar {
  padding: 0.5rem;
}
.top-bar::after,
.top-bar::before {
  display: table;
  content: ' ';
}
.top-bar::after {
  clear: both;
}
.top-bar,
.top-bar ul {
  background-color: #e6e6e6;
}
.top-bar input {
  max-width: 200px;
  margin-right: 1rem;
}
.top-bar .input-group-field {
  width: 100%;
  margin-right: 0;
}
.top-bar input.button {
  width: auto;
}
.top-bar .top-bar-left,
.top-bar .top-bar-right {
  width: 100%;
}
@media print, screen and (min-width: 40.0625em) {
  .top-bar .top-bar-left,
  .top-bar .top-bar-right {
    width: auto;
  }
}
@media screen and (max-width: 64.06125em) {
  .top-bar.stacked-for-medium .top-bar-left,
  .top-bar.stacked-for-medium .top-bar-right {
    width: 100%;
  }
}
@media screen and (max-width: 74.99875em) {
  .top-bar.stacked-for-large .top-bar-left,
  .top-bar.stacked-for-large .top-bar-right {
    width: 100%;
  }
}
.top-bar-title {
  display: inline-block;
  float: left;
  padding: 0.5rem 1rem 0.5rem 0;
}
.top-bar-title .menu-icon {
  bottom: 2px;
}
.top-bar-left {
  float: left;
}
.top-bar-right {
  float: right;
}
.hide {
  display: none !important;
}
.invisible {
  visibility: hidden;
}
@media screen and (max-width: 40.06125em) {
  .hide-for-small-only {
    display: none !important;
  }
}
@media screen and (max-width: 0em), screen and (min-width: 40.0625em) {
  .show-for-small-only {
    display: none !important;
  }
}
@media screen and (min-width: 40.0625em) and (max-width: 64.06125em) {
  .hide-for-medium-only {
    display: none !important;
  }
}
@media screen and (max-width: 40.06125em), screen and (min-width: 64.0625em) {
  .show-for-medium-only {
    display: none !important;
  }
}
@media print, screen and (min-width: 64.0625em) {
  .hide-for-large {
    display: none !important;
  }
}
@media screen and (max-width: 64.06125em) {
  .show-for-large {
    display: none !important;
  }
}
@media screen and (min-width: 64.0625em) and (max-width: 74.99875em) {
  .hide-for-large-only {
    display: none !important;
  }
}
@media screen and (max-width: 64.06125em), screen and (min-width: 75em) {
  .show-for-large-only {
    display: none !important;
  }
}
.show-for-sr,
.show-on-focus {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.show-on-focus:active,
.show-on-focus:focus {
  position: static !important;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.hide-for-portrait,
.show-for-landscape {
  display: block !important;
}
@media screen and (orientation: landscape) {
  .hide-for-portrait,
  .show-for-landscape {
    display: block !important;
  }
}
@media screen and (orientation: portrait) {
  .hide-for-portrait,
  .show-for-landscape {
    display: none !important;
  }
}
.hide-for-landscape,
.show-for-portrait {
  display: none !important;
}
@media screen and (orientation: landscape) {
  .hide-for-landscape,
  .show-for-portrait {
    display: none !important;
  }
}
@media screen and (orientation: portrait) {
  .hide-for-landscape,
  .show-for-portrait {
    display: block !important;
  }
}
.float-left {
  float: left !important;
}
.float-right {
  float: right !important;
}
.float-center {
  display: block;
  margin-right: auto;
  margin-left: auto;
}
.clearfix::after,
.clearfix::before {
  display: table;
  content: ' ';
}
.clearfix::after {
  clear: both;
}
.slide-in-down.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: translateY(-100%);
  -ms-transform: translateY(-100%);
  transform: translateY(-100%);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.slide-in-down.mui-enter.mui-enter-active {
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
  transform: translateY(0);
}
.slide-in-left.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  transform: translateX(-100%);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.slide-in-left.mui-enter.mui-enter-active {
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translateX(0);
}
.slide-in-up.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: translateY(100%);
  -ms-transform: translateY(100%);
  transform: translateY(100%);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.slide-in-up.mui-enter.mui-enter-active {
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
  transform: translateY(0);
}
.slide-in-right.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.slide-in-right.mui-enter.mui-enter-active {
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translateX(0);
}
.slide-out-down.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
  transform: translateY(0);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.slide-out-down.mui-leave.mui-leave-active {
  -webkit-transform: translateY(100%);
  -ms-transform: translateY(100%);
  transform: translateY(100%);
}
.slide-out-right.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translateX(0);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.slide-out-right.mui-leave.mui-leave-active {
  -webkit-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%);
}
.slide-out-up.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
  transform: translateY(0);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.slide-out-up.mui-leave.mui-leave-active {
  -webkit-transform: translateY(-100%);
  -ms-transform: translateY(-100%);
  transform: translateY(-100%);
}
.slide-out-left.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translateX(0);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.slide-out-left.mui-leave.mui-leave-active {
  -webkit-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  transform: translateX(-100%);
}
.fade-in.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  opacity: 0;
  -webkit-transition-property: opacity;
  transition-property: opacity;
}
.fade-in.mui-enter.mui-enter-active {
  opacity: 1;
}
.fade-out.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  opacity: 1;
  -webkit-transition-property: opacity;
  transition-property: opacity;
}
.fade-out.mui-leave.mui-leave-active {
  opacity: 0;
}
.hinge-in-from-top.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: perspective(2000px) rotateX(-90deg);
  transform: perspective(2000px) rotateX(-90deg);
  -webkit-transform-origin: top;
  -ms-transform-origin: top;
  transform-origin: top;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 0;
}
.hinge-in-from-top.mui-enter.mui-enter-active {
  -webkit-transform: perspective(2000px) rotate(0);
  transform: perspective(2000px) rotate(0);
  opacity: 1;
}
.hinge-in-from-right.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: perspective(2000px) rotateY(-90deg);
  transform: perspective(2000px) rotateY(-90deg);
  -webkit-transform-origin: right;
  -ms-transform-origin: right;
  transform-origin: right;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 0;
}
.hinge-in-from-right.mui-enter.mui-enter-active {
  -webkit-transform: perspective(2000px) rotate(0);
  transform: perspective(2000px) rotate(0);
  opacity: 1;
}
.hinge-in-from-bottom.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: perspective(2000px) rotateX(90deg);
  transform: perspective(2000px) rotateX(90deg);
  -webkit-transform-origin: bottom;
  -ms-transform-origin: bottom;
  transform-origin: bottom;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 0;
}
.hinge-in-from-bottom.mui-enter.mui-enter-active {
  -webkit-transform: perspective(2000px) rotate(0);
  transform: perspective(2000px) rotate(0);
  opacity: 1;
}
.hinge-in-from-left.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: perspective(2000px) rotateY(90deg);
  transform: perspective(2000px) rotateY(90deg);
  -webkit-transform-origin: left;
  -ms-transform-origin: left;
  transform-origin: left;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 0;
}
.hinge-in-from-left.mui-enter.mui-enter-active {
  -webkit-transform: perspective(2000px) rotate(0);
  transform: perspective(2000px) rotate(0);
  opacity: 1;
}
.hinge-in-from-middle-x.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: perspective(2000px) rotateX(-90deg);
  transform: perspective(2000px) rotateX(-90deg);
  -webkit-transform-origin: center;
  -ms-transform-origin: center;
  transform-origin: center;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 0;
}
.hinge-in-from-middle-x.mui-enter.mui-enter-active {
  -webkit-transform: perspective(2000px) rotate(0);
  transform: perspective(2000px) rotate(0);
  opacity: 1;
}
.hinge-in-from-middle-y.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: perspective(2000px) rotateY(-90deg);
  transform: perspective(2000px) rotateY(-90deg);
  -webkit-transform-origin: center;
  -ms-transform-origin: center;
  transform-origin: center;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 0;
}
.hinge-in-from-middle-y.mui-enter.mui-enter-active {
  -webkit-transform: perspective(2000px) rotate(0);
  transform: perspective(2000px) rotate(0);
  opacity: 1;
}
.hinge-out-from-top.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: perspective(2000px) rotate(0);
  transform: perspective(2000px) rotate(0);
  -webkit-transform-origin: top;
  -ms-transform-origin: top;
  transform-origin: top;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 1;
}
.hinge-out-from-top.mui-leave.mui-leave-active {
  -webkit-transform: perspective(2000px) rotateX(90deg);
  transform: perspective(2000px) rotateX(90deg);
  opacity: 0;
}
.hinge-out-from-right.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: perspective(2000px) rotate(0);
  transform: perspective(2000px) rotate(0);
  -webkit-transform-origin: right;
  -ms-transform-origin: right;
  transform-origin: right;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 1;
}
.hinge-out-from-right.mui-leave.mui-leave-active {
  -webkit-transform: perspective(2000px) rotateY(90deg);
  transform: perspective(2000px) rotateY(90deg);
  opacity: 0;
}
.hinge-out-from-bottom.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: perspective(2000px) rotate(0);
  transform: perspective(2000px) rotate(0);
  -webkit-transform-origin: bottom;
  -ms-transform-origin: bottom;
  transform-origin: bottom;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 1;
}
.hinge-out-from-bottom.mui-leave.mui-leave-active {
  -webkit-transform: perspective(2000px) rotateX(-90deg);
  transform: perspective(2000px) rotateX(-90deg);
  opacity: 0;
}
.hinge-out-from-left.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: perspective(2000px) rotate(0);
  transform: perspective(2000px) rotate(0);
  -webkit-transform-origin: left;
  -ms-transform-origin: left;
  transform-origin: left;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 1;
}
.hinge-out-from-left.mui-leave.mui-leave-active {
  -webkit-transform: perspective(2000px) rotateY(-90deg);
  transform: perspective(2000px) rotateY(-90deg);
  opacity: 0;
}
.hinge-out-from-middle-x.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: perspective(2000px) rotate(0);
  transform: perspective(2000px) rotate(0);
  -webkit-transform-origin: center;
  -ms-transform-origin: center;
  transform-origin: center;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 1;
}
.hinge-out-from-middle-x.mui-leave.mui-leave-active {
  -webkit-transform: perspective(2000px) rotateX(90deg);
  transform: perspective(2000px) rotateX(90deg);
  opacity: 0;
}
.hinge-out-from-middle-y.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: perspective(2000px) rotate(0);
  transform: perspective(2000px) rotate(0);
  -webkit-transform-origin: center;
  -ms-transform-origin: center;
  transform-origin: center;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 1;
}
.hinge-out-from-middle-y.mui-leave.mui-leave-active {
  -webkit-transform: perspective(2000px) rotateY(90deg);
  transform: perspective(2000px) rotateY(90deg);
  opacity: 0;
}
.scale-in-up.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: scale(0.5);
  -ms-transform: scale(0.5);
  transform: scale(0.5);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 0;
}
.scale-in-up.mui-enter.mui-enter-active {
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  opacity: 1;
}
.scale-in-down.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: scale(1.5);
  -ms-transform: scale(1.5);
  transform: scale(1.5);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 0;
}
.scale-in-down.mui-enter.mui-enter-active {
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  opacity: 1;
}
.scale-out-up.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 1;
}
.scale-out-up.mui-leave.mui-leave-active {
  -webkit-transform: scale(1.5);
  -ms-transform: scale(1.5);
  transform: scale(1.5);
  opacity: 0;
}
.scale-out-down.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 1;
}
.scale-out-down.mui-leave.mui-leave-active {
  -webkit-transform: scale(0.5);
  -ms-transform: scale(0.5);
  transform: scale(0.5);
  opacity: 0;
}
.spin-in.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: rotate(-0.75turn);
  -ms-transform: rotate(-0.75turn);
  transform: rotate(-0.75turn);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 0;
}
.spin-in.mui-enter.mui-enter-active {
  -webkit-transform: rotate(0);
  -ms-transform: rotate(0);
  transform: rotate(0);
  opacity: 1;
}
.spin-out.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: rotate(0);
  -ms-transform: rotate(0);
  transform: rotate(0);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 1;
}
.spin-out.mui-leave.mui-leave-active {
  -webkit-transform: rotate(0.75turn);
  -ms-transform: rotate(0.75turn);
  transform: rotate(0.75turn);
  opacity: 0;
}
.spin-in-ccw.mui-enter {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: rotate(0.75turn);
  -ms-transform: rotate(0.75turn);
  transform: rotate(0.75turn);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 0;
}
.spin-in-ccw.mui-enter.mui-enter-active {
  -webkit-transform: rotate(0);
  -ms-transform: rotate(0);
  transform: rotate(0);
  opacity: 1;
}
.spin-out-ccw.mui-leave {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
  -webkit-transform: rotate(0);
  -ms-transform: rotate(0);
  transform: rotate(0);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
  opacity: 1;
}
.spin-out-ccw.mui-leave.mui-leave-active {
  -webkit-transform: rotate(-0.75turn);
  -ms-transform: rotate(-0.75turn);
  transform: rotate(-0.75turn);
  opacity: 0;
}
.slow {
  -webkit-transition-duration: 750ms !important;
  transition-duration: 750ms !important;
}
.fast {
  -webkit-transition-duration: 250ms !important;
  transition-duration: 250ms !important;
}
.linear {
  -webkit-transition-timing-function: linear !important;
  transition-timing-function: linear !important;
}
.ease {
  -webkit-transition-timing-function: ease !important;
  transition-timing-function: ease !important;
}
.ease-in {
  -webkit-transition-timing-function: ease-in !important;
  transition-timing-function: ease-in !important;
}
.ease-out {
  -webkit-transition-timing-function: ease-out !important;
  transition-timing-function: ease-out !important;
}
.ease-in-out {
  -webkit-transition-timing-function: ease-in-out !important;
  transition-timing-function: ease-in-out !important;
}
.bounce-in {
  -webkit-transition-timing-function: cubic-bezier(0.485, 0.155, 0.24, 1.245) !important;
  transition-timing-function: cubic-bezier(0.485, 0.155, 0.24, 1.245) !important;
}
.bounce-out {
  -webkit-transition-timing-function: cubic-bezier(0.485, 0.155, 0.515, 0.845) !important;
  transition-timing-function: cubic-bezier(0.485, 0.155, 0.515, 0.845) !important;
}
.bounce-in-out {
  -webkit-transition-timing-function: cubic-bezier(0.76, -0.245, 0.24, 1.245) !important;
  transition-timing-function: cubic-bezier(0.76, -0.245, 0.24, 1.245) !important;
}
.short-delay {
  -webkit-transition-delay: 0.3s !important;
  transition-delay: 0.3s !important;
}
.long-delay {
  -webkit-transition-delay: 0.7s !important;
  transition-delay: 0.7s !important;
}
.shake {
  -webkit-animation-name: shake-7;
  animation-name: shake-7;
}
@-webkit-keyframes shake-7 {
  0%,
  10%,
  20%,
  30%,
  40%,
  50%,
  60%,
  70%,
  80%,
  90% {
    -webkit-transform: translateX(7%);
    transform: translateX(7%);
  }
  15%,
  25%,
  35%,
  45%,
  5%,
  55%,
  65%,
  75%,
  85%,
  95% {
    -webkit-transform: translateX(-7%);
    transform: translateX(-7%);
  }
}
@keyframes shake-7 {
  0%,
  10%,
  20%,
  30%,
  40%,
  50%,
  60%,
  70%,
  80%,
  90% {
    -webkit-transform: translateX(7%);
    transform: translateX(7%);
  }
  15%,
  25%,
  35%,
  45%,
  5%,
  55%,
  65%,
  75%,
  85%,
  95% {
    -webkit-transform: translateX(-7%);
    transform: translateX(-7%);
  }
}
.spin-cw {
  -webkit-animation-name: spin-cw-1turn;
  animation-name: spin-cw-1turn;
}
@-webkit-keyframes spin-cw-1turn {
  0% {
    -webkit-transform: rotate(-1turn);
    transform: rotate(-1turn);
  }
  100% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
}
@keyframes spin-cw-1turn {
  0% {
    -webkit-transform: rotate(-1turn);
    transform: rotate(-1turn);
  }
  100% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
}
.spin-ccw {
  -webkit-animation-name: spin-ccw-1turn;
  animation-name: spin-ccw-1turn;
}
@-webkit-keyframes spin-ccw-1turn {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(-1turn);
    transform: rotate(-1turn);
  }
}
@keyframes spin-ccw-1turn {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(-1turn);
    transform: rotate(-1turn);
  }
}
.wiggle {
  -webkit-animation-name: wiggle-7deg;
  animation-name: wiggle-7deg;
}
@-webkit-keyframes wiggle-7deg {
  40%,
  50%,
  60% {
    -webkit-transform: rotate(7deg);
    transform: rotate(7deg);
  }
  35%,
  45%,
  55%,
  65% {
    -webkit-transform: rotate(-7deg);
    transform: rotate(-7deg);
  }
  0%,
  100%,
  30%,
  70% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
}
@keyframes wiggle-7deg {
  40%,
  50%,
  60% {
    -webkit-transform: rotate(7deg);
    transform: rotate(7deg);
  }
  35%,
  45%,
  55%,
  65% {
    -webkit-transform: rotate(-7deg);
    transform: rotate(-7deg);
  }
  0%,
  100%,
  30%,
  70% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
}
.shake,
.spin-ccw,
.spin-cw,
.wiggle {
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
}
.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
.slow {
  -webkit-animation-duration: 750ms !important;
  animation-duration: 750ms !important;
}
.fast {
  -webkit-animation-duration: 250ms !important;
  animation-duration: 250ms !important;
}
.linear {
  -webkit-animation-timing-function: linear !important;
  animation-timing-function: linear !important;
}
.ease {
  -webkit-animation-timing-function: ease !important;
  animation-timing-function: ease !important;
}
.ease-in {
  -webkit-animation-timing-function: ease-in !important;
  animation-timing-function: ease-in !important;
}
.ease-out {
  -webkit-animation-timing-function: ease-out !important;
  animation-timing-function: ease-out !important;
}
.ease-in-out {
  -webkit-animation-timing-function: ease-in-out !important;
  animation-timing-function: ease-in-out !important;
}
.bounce-in {
  -webkit-animation-timing-function: cubic-bezier(0.485, 0.155, 0.24, 1.245) !important;
  animation-timing-function: cubic-bezier(0.485, 0.155, 0.24, 1.245) !important;
}
.bounce-out {
  -webkit-animation-timing-function: cubic-bezier(0.485, 0.155, 0.515, 0.845) !important;
  animation-timing-function: cubic-bezier(0.485, 0.155, 0.515, 0.845) !important;
}
.bounce-in-out {
  -webkit-animation-timing-function: cubic-bezier(0.76, -0.245, 0.24, 1.245) !important;
  animation-timing-function: cubic-bezier(0.76, -0.245, 0.24, 1.245) !important;
}
.short-delay {
  -webkit-animation-delay: 0.3s !important;
  animation-delay: 0.3s !important;
}
.long-delay {
  -webkit-animation-delay: 0.7s !important;
  animation-delay: 0.7s !important;
}
.logo {
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 600;
}

@media screen and (min-width: 640px) {
  .close,
  .open {
    display: none;
  }
}

.stop-scrolling {
  height: 100%;
  overflow: hidden;
}

.questions {
  height: auto;
}
.questions span {
  margin-left: -3px;
  display: block;
  font-size: 16px;
  line-height: 26px;
  font-weight: 600;
  color: #666;
  margin-top: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}
.questions span img {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  width: 0;
  height: 15px;
}
.questions p {
  font-size: 14px;
  line-height: 24px;
  margin: 0;
}
.main {
  background: -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff), to(#f2f2f2));
  background: linear-gradient(180deg, #fff 0, #f2f2f2);
  padding-bottom: 70px;
  padding-top: 40px;
}
label[class*='error'] {
  display: inline-block;
  font-size: 10px;
  color: red;
  font-weight: 600;
}
.error {
  border-color: red !important;
}
textarea[class*='error'] {
  border-color: red;
}
.failed {
  color: red;
}
.success {
  color: #93cb53;
}
.footer {
  border-top: 1px solid #e0e0e0;
}
.footer .linkgroop,
.footer p {
  display: inline-block;
}
.footer .linkgroop a {
  color: #666;
  text-decoration: none;
  position: relative;
  display: inline-block;
}
.footer .linkgroop a,
.footer p {
  font-size: 14px;
  font-weight: 600;
}
.footer .linkgroop a:hover:after {
  left: 0;
  width: 100%;
}
.footer .linkgroop a:after {
  width: 0;
  content: '';
  display: block;
  background: #666;
  bottom: -2px;
  height: 1px;
  left: 50%;
  position: absolute;
  -webkit-transition: all 0.35s ease;
  transition: all 0.35s ease;
}
@media screen and (min-width: 1024px) {
  .footer {
    padding: 26px 0;
  }
  .footer .statement {
    position: relative;
    width: 750px;
    left: 50%;
    margin-left: -375px;
    color: #909090;
  }
  .footer .linkgroop {
    float: right;
  }
  .footer .linkgroop a {
    margin-right: 50px;
  }
  .footer p,
  .footer ul {
    margin: 0;
  }
  .footer .credit {
    line-height: 30px;
    vertical-align: bottom;
    padding-left: 20px;
  }
}
@media screen and (max-width: 1023px) {
  .footer {
    text-align: center;
  }
  .footer .statement {
    padding: 20px 10% 0;
  }
  .footer .row {
    padding-bottom: 15px;
  }
  .footer div,
  .footer p,
  .footer ul {
    display: block;
  }
  .footer .linkgroop a {
    margin: 0 20px;
  }
  .footer ul {
    margin: 10px 0;
  }
}
.language_selector {
  position: absolute;
  right: 10px;
  margin-right: 30px;
  display: inline-block;
  width: 115px;
  line-height: 39px;
  color: #fff;
  font-size: 16px;
  padding: 0 10px;
  cursor: pointer;
  text-align: left;
  padding-left: 15px;
  border: 2px solid #666;
  border-radius: 30px;
  background-color: #f2f2f2;
  color: #0a0a0a;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.active_selector {
  border-radius: 30px 30px 0 0 !important;
}
.language_selector img {
  position: absolute;
  height: 39px;
  width: 50px;
  padding-left: 10px;
  padding-bottom: 5px;
  padding-top: 5px;
  right: 15px;
}
.languages {
  position: relative;
  width: 115px;
  border: 2px solid #666;
  border-radius: 0 0 30px 30px !important;
  display: none;
  outline: 0;
  z-index: 3;
  margin: 0 30px 0 0;
  list-style-type: none;
  padding: 0;
  border-radius: 0 0 24px 24px;
  background-color: #f2f2f2;
}
.languages > li {
  width: 100%;
  height: 39px;
  line-height: 25px;
  font-size: 12px;
  cursor: pointer;
}
.languages > li a {
  color: #000;
  font-size: 16px;
}
@media screen and (max-width: 639px) {
  .languages {
    top: 41px;
    right: 10px;
  }
  .language_selector,
  .languages,
  .languages > li {
    width: 95px;
  }
  .language_selector,
  .languages {
    margin-left: 5px;
  }
  .language_selector,
  .languages > li > a {
    color: #000;
  }
}
.languages > li:hover {
  -webkit-transition: background, 0.3s;
  transition: background, 0.3s;
  background: rgba(255, 255, 255, 0.1);
}
.lang {
  margin: 0;
}
.lang a {
  width: inherit;
  display: block;
  height: 39px;
  line-height: 39px;
}
.lang a span {
  display: block;
  height: 39px;
  line-height: 39px;
  text-align: left;
  padding-left: 15px;
  position: relative;
  text-transform: capitalize;
}
.lang a span img {
  position: absolute;
  height: 39px;
  width: 50px;
  padding-left: 10px;
  padding-bottom: 5px;
  padding-top: 5px;
  right: 15px;
}
.language_selector svg {
  position: absolute;
  height: 39px;
  width: 50px;
  padding-left: 10px;
  right: 15px;
}
@media screen and (min-width: 640px) {
  .languages {
    top: 41px;
    right: 10px;
  }
}
</style>
